import { defineStore as Sa, skipHydrate as Dr } from "pinia";
import { watch as le, shallowRef as _e, shallowReadonly as wa, toValue as P, ref as I, computed as v, getCurrentInstance as st, onMounted as sr, getCurrentScope as Ft, onScopeDispose as Lt, reactive as me, watchEffect as Qe, isRef as xe, inject as ur, triggerRef as ja, nextTick as Ze, unref as We, effectScope as ye, toRef as K, readonly as Jr, version as ka } from "vue";
const Ra = {
  lang: void 0,
  message: void 0,
  abortEarly: void 0,
  abortPipeEarly: void 0
};
// @__NO_SIDE_EFFECTS__
function Kr(e) {
  return Ra;
}
let xa;
// @__NO_SIDE_EFFECTS__
function Ia(e) {
  return xa?.get(e);
}
let Pa;
// @__NO_SIDE_EFFECTS__
function Da(e) {
  return Pa?.get(e);
}
let _a;
// @__NO_SIDE_EFFECTS__
function Ta(e, t) {
  return _a?.get(e)?.get(t);
}
// @__NO_SIDE_EFFECTS__
function ut(e) {
  const t = typeof e;
  return t === "string" ? `"${e}"` : t === "number" || t === "bigint" || t === "boolean" ? `${e}` : t === "object" || t === "function" ? (e && Object.getPrototypeOf(e)?.constructor?.name) ?? "null" : t;
}
function fe(e, t, r, a, n) {
  const s = n && "input" in n ? n.input : r.value, l = n?.expected ?? e.expects ?? null, i = n?.received ?? /* @__PURE__ */ ut(s), o = {
    kind: e.kind,
    type: e.type,
    input: s,
    expected: l,
    received: i,
    message: `Invalid ${t}: ${l ? `Expected ${l} but r` : "R"}eceived ${i}`,
    requirement: e.requirement,
    path: n?.path,
    issues: n?.issues,
    lang: a.lang,
    abortEarly: a.abortEarly,
    abortPipeEarly: a.abortPipeEarly
  }, f = e.kind === "schema", u = n?.message ?? e.message ?? /* @__PURE__ */ Ta(e.reference, o.lang) ?? (f ? /* @__PURE__ */ Da(o.lang) : null) ?? a.message ?? /* @__PURE__ */ Ia(o.lang);
  u !== void 0 && (o.message = typeof u == "function" ? u(o) : u), f && (r.typed = !1), r.issues ? r.issues.push(o) : r.issues = [o];
}
let wt;
// @__NO_SIDE_EFFECTS__
function Na(e, t) {
  wt || (wt = /* @__PURE__ */ new Map());
  const r = String(e);
  let a = wt.get(r);
  a || (a = new Intl.Segmenter(e, { granularity: "word" }), wt.set(r, a));
  const n = a.segment(t);
  let s = 0;
  for (const l of n) l.isWordLike && s++;
  return s;
}
// @__NO_SIDE_EFFECTS__
function Bt(e, t) {
  return e === t || Number.isNaN(e) && Number.isNaN(t);
}
// @__NO_SIDE_EFFECTS__
function or(e, t) {
  const r = [...new Set(e)];
  return r.length > 1 ? `(${r.join(` ${t} `)})` : r[0] ?? "never";
}
function Ae(e) {
  return e["~standard"] = {
    version: 1,
    vendor: "valibot",
    validate: (t) => e["~run"]({ value: t }, /* @__PURE__ */ Kr())
  }, e;
}
// @__NO_SIDE_EFFECTS__
function Ca(e) {
  if (e.path) {
    let t = "";
    for (const r of e.path) if (typeof r.key == "string" || typeof r.key == "number") t ? t += `.${r.key}` : t += r.key;
    else return null;
    return t;
  }
  return null;
}
const Va = /^[\w+-]+(?:\.[\w+-]+)*@[\da-zA-Z]+(?:[.-][\da-zA-Z]+)*\.[a-zA-Z]{2,}$/u;
// @__NO_SIDE_EFFECTS__
function Yr(e, t) {
  return {
    kind: "validation",
    type: "check",
    reference: Yr,
    async: !1,
    expects: null,
    requirement: e,
    message: t,
    "~run"(r, a) {
      return r.typed && !this.requirement(r.value) && fe(this, "input", r, a), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Qr(e, t) {
  return {
    kind: "validation",
    type: "check_items",
    reference: Qr,
    async: !1,
    expects: null,
    requirement: e,
    message: t,
    "~run"(r, a) {
      if (r.typed) for (let n = 0; n < r.value.length; n++) {
        const s = r.value[n];
        this.requirement(s, n, r.value) || fe(this, "item", r, a, {
          input: s,
          path: [{
            type: "array",
            origin: "value",
            input: r.value,
            key: n,
            value: s
          }]
        });
      }
      return r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Zr(e) {
  return {
    kind: "validation",
    type: "email",
    reference: Zr,
    expects: null,
    async: !1,
    requirement: Va,
    message: e,
    "~run"(t, r) {
      return t.typed && !this.requirement.test(t.value) && fe(this, "email", t, r), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Xr(e, t) {
  return {
    kind: "validation",
    type: "max_length",
    reference: Xr,
    async: !1,
    expects: `<=${e}`,
    requirement: e,
    message: t,
    "~run"(r, a) {
      return r.typed && r.value.length > this.requirement && fe(this, "length", r, a, { received: `${r.value.length}` }), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Jt(e, t) {
  return {
    kind: "validation",
    type: "max_value",
    reference: Jt,
    async: !1,
    expects: `<=${e instanceof Date ? e.toJSON() : /* @__PURE__ */ ut(e)}`,
    requirement: e,
    message: t,
    "~run"(r, a) {
      return r.typed && !(r.value <= this.requirement) && fe(this, "value", r, a, { received: r.value instanceof Date ? r.value.toJSON() : /* @__PURE__ */ ut(r.value) }), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Kt(e, t, r) {
  return {
    kind: "validation",
    type: "max_words",
    reference: Kt,
    async: !1,
    expects: `<=${t}`,
    locales: e,
    requirement: t,
    message: r,
    "~run"(a, n) {
      if (a.typed) {
        const s = /* @__PURE__ */ Na(this.locales, a.value);
        s > this.requirement && fe(this, "words", a, n, { received: `${s}` });
      }
      return a;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function xt(e, t) {
  return {
    kind: "validation",
    type: "min_length",
    reference: xt,
    async: !1,
    expects: `>=${e}`,
    requirement: e,
    message: t,
    "~run"(r, a) {
      return r.typed && r.value.length < this.requirement && fe(this, "length", r, a, { received: `${r.value.length}` }), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function It(e, t) {
  return {
    kind: "validation",
    type: "min_value",
    reference: It,
    async: !1,
    expects: `>=${e instanceof Date ? e.toJSON() : /* @__PURE__ */ ut(e)}`,
    requirement: e,
    message: t,
    "~run"(r, a) {
      return r.typed && !(r.value >= this.requirement) && fe(this, "value", r, a, { received: r.value instanceof Date ? r.value.toJSON() : /* @__PURE__ */ ut(r.value) }), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ea(e, t) {
  return {
    kind: "validation",
    type: "not_length",
    reference: ea,
    async: !1,
    expects: `!${e}`,
    requirement: e,
    message: t,
    "~run"(r, a) {
      return r.typed && r.value.length === this.requirement && fe(this, "length", r, a, { received: `${r.value.length}` }), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function ht(e, t) {
  return {
    kind: "validation",
    type: "regex",
    reference: ht,
    async: !1,
    expects: `${e}`,
    requirement: e,
    message: t,
    "~run"(r, a) {
      return r.typed && !this.requirement.test(r.value) && fe(this, "format", r, a), r;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function lt(e) {
  return {
    kind: "transformation",
    type: "transform",
    reference: lt,
    async: !1,
    operation: e,
    "~run"(t) {
      return t.value = this.operation(t.value), t;
    }
  };
}
// @__NO_SIDE_EFFECTS__
function Ue() {
  return {
    kind: "transformation",
    type: "trim",
    reference: Ue,
    async: !1,
    "~run"(e) {
      return e.value = e.value.trim(), e;
    }
  };
}
const Fa = { abortEarly: !0 };
// @__NO_SIDE_EFFECTS__
function La(e, t, r) {
  return typeof e.fallback == "function" ? e.fallback(t, r) : e.fallback;
}
// @__NO_SIDE_EFFECTS__
function Ma(e) {
  const t = {};
  for (const r of e) if (r.path) {
    const a = /* @__PURE__ */ Ca(r);
    a ? (t.nested || (t.nested = {}), Object.prototype.hasOwnProperty.call(t.nested, a) ? t.nested[a].push(r.message) : t.nested[a] = [r.message]) : t.other ? t.other.push(r.message) : t.other = [r.message];
  } else t.root ? t.root.push(r.message) : t.root = [r.message];
  return t;
}
// @__NO_SIDE_EFFECTS__
function ta(e, t, r) {
  return typeof e.default == "function" ? e.default(t, r) : e.default;
}
// @__NO_SIDE_EFFECTS__
function Yt(e, t) {
  return Ae({
    kind: "schema",
    type: "array",
    reference: Yt,
    expects: "Array",
    async: !1,
    item: e,
    message: t,
    "~run"(r, a) {
      const n = r.value;
      if (Array.isArray(n)) {
        r.typed = !0, r.value = [];
        for (let s = 0; s < n.length; s++) {
          const l = n[s], i = this.item["~run"]({ value: l }, a);
          if (i.issues) {
            const o = {
              type: "array",
              origin: "value",
              input: n,
              key: s,
              value: l
            };
            for (const f of i.issues)
              f.path ? f.path.unshift(o) : f.path = [o], r.issues?.push(f);
            if (r.issues || (r.issues = i.issues), a.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          i.typed || (r.typed = !1), r.value.push(i.value);
        }
      } else fe(this, "type", r, a);
      return r;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function ra(e) {
  return Ae({
    kind: "schema",
    type: "boolean",
    reference: ra,
    expects: "boolean",
    async: !1,
    message: e,
    "~run"(t, r) {
      return typeof t.value == "boolean" ? t.typed = !0 : fe(this, "type", t, r), t;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function Qt(e, t) {
  if (typeof e == typeof t) {
    if (/* @__PURE__ */ Bt(e, t) || e instanceof Date && t instanceof Date && /* @__PURE__ */ Bt(+e, +t)) return { value: e };
    if (e && t && e.constructor === Object && t.constructor === Object) {
      const r = {
        ...e,
        ...t
      };
      for (const a in t) if (Object.prototype.hasOwnProperty.call(e, a) && Object.prototype.hasOwnProperty.call(t, a)) {
        const n = /* @__PURE__ */ Qt(e[a], t[a]);
        if (n.issue) return n;
        r[a] = n.value;
      }
      return { value: r };
    }
    if (Array.isArray(e) && Array.isArray(t) && e.length === t.length) {
      const r = [...e];
      for (let a = 0; a < e.length; a++) {
        const n = /* @__PURE__ */ Qt(e[a], t[a]);
        if (n.issue) return n;
        r[a] = n.value;
      }
      return { value: r };
    }
  }
  return { issue: !0 };
}
// @__NO_SIDE_EFFECTS__
function aa(e, t) {
  return Ae({
    kind: "schema",
    type: "intersect",
    reference: aa,
    expects: /* @__PURE__ */ or(e.map((r) => r.expects), "&"),
    async: !1,
    options: e,
    message: t,
    "~run"(r, a) {
      if (this.options.length) {
        const n = r.value;
        let s;
        r.typed = !0;
        for (const l of this.options) {
          const i = l["~run"]({ value: n }, a);
          if (i.issues) {
            if (r.issues) for (const o of i.issues) r.issues.push(o);
            else r.issues = i.issues;
            if (a.abortEarly) {
              r.typed = !1;
              break;
            }
          }
          i.typed || (r.typed = !1), r.typed && (s ? s.push(i.value) : s = [i.value]);
        }
        if (r.typed) {
          r.value = s[0];
          for (let l = 1; l < s.length; l++) {
            const i = /* @__PURE__ */ Qt(r.value, s[l]);
            if (i.issue) {
              fe(this, "type", r, a, { received: "unknown" });
              break;
            }
            r.value = i.value;
          }
        }
      } else fe(this, "type", r, a);
      return r;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function He(e, t) {
  return Ae({
    kind: "schema",
    type: "literal",
    reference: He,
    expects: /* @__PURE__ */ ut(e),
    async: !1,
    literal: e,
    message: t,
    "~run"(r, a) {
      return /* @__PURE__ */ Bt(r.value, this.literal) ? r.typed = !0 : fe(this, "type", r, a), r;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function Dt(e, t) {
  return Ae({
    kind: "schema",
    type: "non_optional",
    reference: Dt,
    expects: "!undefined",
    async: !1,
    wrapped: e,
    message: t,
    "~run"(r, a) {
      return r.value !== void 0 && (r = this.wrapped["~run"](r, a)), r.value === void 0 && fe(this, "type", r, a), r;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function Me(e) {
  return Ae({
    kind: "schema",
    type: "number",
    reference: Me,
    expects: "number",
    async: !1,
    message: e,
    "~run"(t, r) {
      return typeof t.value == "number" && !isNaN(t.value) ? t.typed = !0 : fe(this, "type", t, r), t;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function qe(e, t) {
  return Ae({
    kind: "schema",
    type: "object",
    reference: qe,
    expects: "Object",
    async: !1,
    entries: e,
    message: t,
    "~run"(r, a) {
      const n = r.value;
      if (n && typeof n == "object") {
        r.typed = !0, r.value = {};
        for (const s in this.entries) {
          const l = this.entries[s];
          if (s in n || (l.type === "exact_optional" || l.type === "optional" || l.type === "nullish") && l.default !== void 0) {
            const i = s in n ? n[s] : /* @__PURE__ */ ta(l), o = l["~run"]({ value: i }, a);
            if (o.issues) {
              const f = {
                type: "object",
                origin: "value",
                input: n,
                key: s,
                value: i
              };
              for (const u of o.issues)
                u.path ? u.path.unshift(f) : u.path = [f], r.issues?.push(u);
              if (r.issues || (r.issues = o.issues), a.abortEarly) {
                r.typed = !1;
                break;
              }
            }
            o.typed || (r.typed = !1), r.value[s] = o.value;
          } else if (l.fallback !== void 0) r.value[s] = /* @__PURE__ */ La(l);
          else if (l.type !== "exact_optional" && l.type !== "optional" && l.type !== "nullish" && (fe(this, "key", r, a, {
            input: void 0,
            expected: `"${s}"`,
            path: [{
              type: "object",
              origin: "key",
              input: n,
              key: s,
              value: n[s]
            }]
          }), a.abortEarly))
            break;
        }
      } else fe(this, "type", r, a);
      return r;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function cr(e, t) {
  return Ae({
    kind: "schema",
    type: "optional",
    reference: cr,
    expects: `(${e.expects} | undefined)`,
    async: !1,
    wrapped: e,
    default: t,
    "~run"(r, a) {
      return r.value === void 0 && (this.default !== void 0 && (r.value = /* @__PURE__ */ ta(this, r, a)), r.value === void 0) ? (r.typed = !0, r) : this.wrapped["~run"](r, a);
    }
  });
}
// @__NO_SIDE_EFFECTS__
function Te(e) {
  return Ae({
    kind: "schema",
    type: "string",
    reference: Te,
    expects: "string",
    async: !1,
    message: e,
    "~run"(t, r) {
      return typeof t.value == "string" ? t.typed = !0 : fe(this, "type", t, r), t;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function na(e) {
  return Ae({
    kind: "schema",
    type: "undefined",
    reference: na,
    expects: "undefined",
    async: !1,
    message: e,
    "~run"(t, r) {
      return t.value === void 0 ? t.typed = !0 : fe(this, "type", t, r), t;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function _r(e) {
  let t;
  if (e) for (const r of e) if (t) for (const a of r.issues) t.push(a);
  else t = r.issues;
  return t;
}
// @__NO_SIDE_EFFECTS__
function fr(e, t) {
  return Ae({
    kind: "schema",
    type: "union",
    reference: fr,
    expects: /* @__PURE__ */ or(e.map((r) => r.expects), "|"),
    async: !1,
    options: e,
    message: t,
    "~run"(r, a) {
      let n, s, l;
      for (const i of this.options) {
        const o = i["~run"]({ value: r.value }, a);
        if (o.typed) if (o.issues) s ? s.push(o) : s = [o];
        else {
          n = o;
          break;
        }
        else l ? l.push(o) : l = [o];
      }
      if (n) return n;
      if (s) {
        if (s.length === 1) return s[0];
        fe(this, "type", r, a, { issues: /* @__PURE__ */ _r(s) }), r.typed = !0;
      } else {
        if (l?.length === 1) return l[0];
        fe(this, "type", r, a, { issues: /* @__PURE__ */ _r(l) });
      }
      return r;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function Zt(e, t, r) {
  return Ae({
    kind: "schema",
    type: "variant",
    reference: Zt,
    expects: "Object",
    async: !1,
    key: e,
    options: t,
    message: r,
    "~run"(a, n) {
      const s = a.value;
      if (s && typeof s == "object") {
        let l, i = 0, o = this.key, f = [];
        const u = (m, h) => {
          for (const O of m.options) {
            if (O.type === "variant") u(O, new Set(h).add(O.key));
            else {
              let R = !0, p = 0;
              for (const w of h) {
                const S = O.entries[w];
                if (w in s ? S["~run"]({
                  typed: !1,
                  value: s[w]
                }, Fa).issues : S.type !== "exact_optional" && S.type !== "optional" && S.type !== "nullish") {
                  R = !1, o !== w && (i < p || i === p && w in s && !(o in s)) && (i = p, o = w, f = []), o === w && f.push(O.entries[w].expects);
                  break;
                }
                p++;
              }
              if (R) {
                const w = O["~run"]({ value: s }, n);
                (!l || !l.typed && w.typed) && (l = w);
              }
            }
            if (l && !l.issues) break;
          }
        };
        if (u(this, /* @__PURE__ */ new Set([this.key])), l) return l;
        fe(this, "type", a, n, {
          input: s[o],
          expected: /* @__PURE__ */ or(f, "|"),
          path: [{
            type: "object",
            origin: "value",
            input: s,
            key: o,
            value: s[o]
          }]
        });
      } else fe(this, "type", a, n);
      return a;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function Fe(e, t) {
  return Ae({
    ...e,
    "~run"(r, a) {
      return e["~run"](r, {
        ...a,
        message: t
      });
    }
  });
}
// @__NO_SIDE_EFFECTS__
function qa(e, t) {
  const r = {};
  for (const a in e.entries) r[a] = /* @__PURE__ */ cr(e.entries[a]);
  return Ae({
    ...e,
    entries: r
  });
}
// @__NO_SIDE_EFFECTS__
function ae(...e) {
  return Ae({
    ...e[0],
    pipe: e,
    "~run"(t, r) {
      for (const a of e) if (a.kind !== "metadata") {
        if (t.issues && (a.kind === "schema" || a.kind === "transformation")) {
          t.typed = !1;
          break;
        }
        (!t.issues || !r.abortEarly && !r.abortPipeEarly) && (t = a["~run"](t, r));
      }
      return t;
    }
  });
}
// @__NO_SIDE_EFFECTS__
function Ua(e, t, r) {
  const a = e["~run"]({ value: t }, /* @__PURE__ */ Kr());
  return {
    typed: a.typed,
    success: !a.issues,
    output: a.value,
    issues: a.issues
  };
}
const Xt = {
  Service: "SERVICE",
  Product: "PRODUCT"
}, ql = {
  NOT_AVAILABLE_IN_SCOPE: "NOT_AVAILABLE_IN_SCOPE",
  NO_AVAILABILITY: "NO_AVAILABILITY",
  NO_PRICE: "NO_PRICE"
}, Ge = {
  UNAVAILABLE: 0,
  NO_AVAILABILITY: 1,
  NOT_FOUND: 2,
  AREA_NOT_SUPPORTED: 3
}, Tr = {
  AT_CAPACITY: 0,
  NO_INVENTORY: 1
};
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const at = () => {
};
function Wa(e, t) {
  function r(...a) {
    return new Promise((n, s) => {
      Promise.resolve(e(() => t.apply(this, a), {
        fn: t,
        thisArg: this,
        args: a
      })).then(n).catch(s);
    });
  }
  return "cancel" in e && Object.assign(r, {
    cancel: e.cancel,
    flush: e.flush,
    isPending: e.isPending
  }), r;
}
const za = (e) => e();
function Ga(e, t = {}) {
  let r, a, n = at, s = at;
  const l = _e(!1), i = (u) => {
    clearTimeout(u), n(), n = at;
  };
  let o;
  return Object.assign((u) => {
    const m = P(e), h = P(t.maxWait);
    return r && i(r), m <= 0 || h !== void 0 && h <= 0 ? (a && (i(a), a = void 0), l.value = !1, Promise.resolve(u())) : (l.value = !0, new Promise((O, R) => {
      n = t.rejectOnCancel ? R : O, s = O, o = u, h && !a && (a = setTimeout(() => {
        r && i(r), a = void 0, l.value = !1, O(o());
      }, h)), r = setTimeout(() => {
        a && i(a), a = void 0, l.value = !1, O(u());
      }, m);
    }));
  }, {
    cancel: () => {
      r && (i(r), r = void 0), a && (i(a), a = void 0), l.value = !1, s = at;
    },
    flush: () => {
      if (l.value) {
        r && (clearTimeout(r), r = void 0), a && (clearTimeout(a), a = void 0), l.value = !1;
        const u = s;
        n = at, s = at, u(o());
      }
    },
    isPending: wa(l)
  });
}
function Ha(e, t, r = {}) {
  const { eventFilter: a = za, ...n } = r;
  return le(e, Wa(a, t), n);
}
function Ba(e, t, r = {}) {
  const { debounce: a = 0, maxWait: n = void 0, ...s } = r;
  return Ha(e, t, {
    ...s,
    eventFilter: Ga(a, { maxWait: n })
  });
}
const qt = Ba, Ja = /"(?:_|\\u0{2}5[Ff]){2}(?:p|\\u0{2}70)(?:r|\\u0{2}72)(?:o|\\u0{2}6[Ff])(?:t|\\u0{2}74)(?:o|\\u0{2}6[Ff])(?:_|\\u0{2}5[Ff]){2}"\s*:/, Ka = /"(?:c|\\u0063)(?:o|\\u006[Ff])(?:n|\\u006[Ee])(?:s|\\u0073)(?:t|\\u0074)(?:r|\\u0072)(?:u|\\u0075)(?:c|\\u0063)(?:t|\\u0074)(?:o|\\u006[Ff])(?:r|\\u0072)"\s*:/, Ya = /^\s*["[{]|^\s*-?\d{1,16}(\.\d{1,17})?([Ee][+-]?\d+)?\s*$/;
function Qa(e, t) {
  if (e === "__proto__" || e === "constructor" && t && typeof t == "object" && "prototype" in t) {
    Za(e);
    return;
  }
  return t;
}
function Za(e) {
  console.warn(`[destr] Dropping "${e}" key to prevent prototype pollution.`);
}
function Pt(e, t = {}) {
  if (typeof e != "string")
    return e;
  if (e[0] === '"' && e[e.length - 1] === '"' && e.indexOf("\\") === -1)
    return e.slice(1, -1);
  const r = e.trim();
  if (r.length <= 9)
    switch (r.toLowerCase()) {
      case "true":
        return !0;
      case "false":
        return !1;
      case "undefined":
        return;
      case "null":
        return null;
      case "nan":
        return Number.NaN;
      case "infinity":
        return Number.POSITIVE_INFINITY;
      case "-infinity":
        return Number.NEGATIVE_INFINITY;
    }
  if (!Ya.test(e)) {
    if (t.strict)
      throw new SyntaxError("[destr] Invalid JSON");
    return e;
  }
  try {
    if (Ja.test(e) || Ka.test(e)) {
      if (t.strict)
        throw new Error("[destr] Possible prototype pollution");
      return JSON.parse(e, Qa);
    }
    return JSON.parse(e);
  } catch (a) {
    if (t.strict)
      throw a;
    return e;
  }
}
const Xa = /#/g, en = /&/g, tn = /\//g, rn = /=/g, vr = /\+/g, an = /%5e/gi, nn = /%60/gi, ln = /%7c/gi, sn = /%20/gi;
function un(e) {
  return encodeURI("" + e).replace(ln, "|");
}
function er(e) {
  return un(typeof e == "string" ? e : JSON.stringify(e)).replace(vr, "%2B").replace(sn, "+").replace(Xa, "%23").replace(en, "%26").replace(nn, "`").replace(an, "^").replace(tn, "%2F");
}
function Ut(e) {
  return er(e).replace(rn, "%3D");
}
function la(e = "") {
  try {
    return decodeURIComponent("" + e);
  } catch {
    return "" + e;
  }
}
function on(e) {
  return la(e.replace(vr, " "));
}
function cn(e) {
  return la(e.replace(vr, " "));
}
function fn(e = "") {
  const t = /* @__PURE__ */ Object.create(null);
  e[0] === "?" && (e = e.slice(1));
  for (const r of e.split("&")) {
    const a = r.match(/([^=]+)=?(.*)/) || [];
    if (a.length < 2)
      continue;
    const n = on(a[1]);
    if (n === "__proto__" || n === "constructor")
      continue;
    const s = cn(a[2] || "");
    t[n] === void 0 ? t[n] = s : Array.isArray(t[n]) ? t[n].push(s) : t[n] = [t[n], s];
  }
  return t;
}
function vn(e, t) {
  return (typeof t == "number" || typeof t == "boolean") && (t = String(t)), t ? Array.isArray(t) ? t.map(
    (r) => `${Ut(e)}=${er(r)}`
  ).join("&") : `${Ut(e)}=${er(t)}` : Ut(e);
}
function dn(e) {
  return Object.keys(e).filter((t) => e[t] !== void 0).map((t) => vn(t, e[t])).filter(Boolean).join("&");
}
const pn = /^[\s\w\0+.-]{2,}:([/\\]{1,2})/, yn = /^[\s\w\0+.-]{2,}:([/\\]{2})?/, $n = /^([/\\]\s*){2,}[^/\\]/, mn = /^\.?\//;
function ia(e, t = {}) {
  return typeof t == "boolean" && (t = { acceptRelative: t }), t.strict ? pn.test(e) : yn.test(e) || (t.acceptRelative ? $n.test(e) : !1);
}
function hn(e = "", t) {
  return e.endsWith("/");
}
function gn(e = "", t) {
  return (hn(e) ? e.slice(0, -1) : e) || "/";
}
function bn(e = "", t) {
  return e.endsWith("/") ? e : e + "/";
}
function En(e, t) {
  if (An(t) || ia(e))
    return e;
  const r = gn(t);
  if (e.startsWith(r)) {
    const a = e[r.length];
    if (!a || a === "/" || a === "?")
      return e;
  }
  return wn(r, e);
}
function On(e, t) {
  const r = jn(e), a = { ...fn(r.search), ...t };
  return r.search = dn(a), kn(r);
}
function An(e) {
  return !e || e === "/";
}
function Sn(e) {
  return e && e !== "/";
}
function wn(e, ...t) {
  let r = e || "";
  for (const a of t.filter((n) => Sn(n)))
    if (r) {
      const n = a.replace(mn, "");
      r = bn(r) + n;
    } else
      r = a;
  return r;
}
const sa = /* @__PURE__ */ Symbol.for("ufo:protocolRelative");
function jn(e = "", t) {
  const r = e.match(
    /^[\s\0]*(blob:|data:|javascript:|vbscript:)(.*)/i
  );
  if (r) {
    const [, m, h = ""] = r;
    return {
      protocol: m.toLowerCase(),
      pathname: h,
      href: m + h,
      auth: "",
      host: "",
      search: "",
      hash: ""
    };
  }
  if (!ia(e, { acceptRelative: !0 }))
    return Nr(e);
  const [, a = "", n, s = ""] = e.replace(/\\/g, "/").match(/^[\s\0]*([\w+.-]{2,}:)?\/\/([^/@]+@)?(.*)/) || [];
  let [, l = "", i = ""] = s.match(/([^#/?]*)(.*)?/) || [];
  a === "file:" && (i = i.replace(/\/(?=[A-Za-z]:)/, ""));
  const { pathname: o, search: f, hash: u } = Nr(i);
  return {
    protocol: a.toLowerCase(),
    auth: n ? n.slice(0, Math.max(0, n.length - 1)) : "",
    host: l,
    pathname: o,
    search: f,
    hash: u,
    [sa]: !a
  };
}
function Nr(e = "") {
  const [t = "", r = "", a = ""] = (e.match(/([^#?]*)(\?[^#]*)?(#.*)?/) || []).splice(1);
  return {
    pathname: t,
    search: r,
    hash: a
  };
}
function kn(e) {
  const t = e.pathname || "", r = e.search ? (e.search.startsWith("?") ? "" : "?") + e.search : "", a = e.hash || "", n = e.auth ? e.auth + "@" : "", s = e.host || "";
  return (e.protocol || e[sa] ? (e.protocol || "") + "//" : "") + n + s + t + r + a;
}
class Rn extends Error {
  constructor(t, r) {
    super(t, r), this.name = "FetchError", r?.cause && !this.cause && (this.cause = r.cause);
  }
}
function xn(e) {
  const t = e.error?.message || e.error?.toString() || "", r = e.request?.method || e.options?.method || "GET", a = e.request?.url || String(e.request) || "/", n = `[${r}] ${JSON.stringify(a)}`, s = e.response ? `${e.response.status} ${e.response.statusText}` : "<no response>", l = `${n}: ${s}${t ? ` ${t}` : ""}`, i = new Rn(
    l,
    e.error ? { cause: e.error } : void 0
  );
  for (const o of ["request", "options", "response"])
    Object.defineProperty(i, o, {
      get() {
        return e[o];
      }
    });
  for (const [o, f] of [
    ["data", "_data"],
    ["status", "status"],
    ["statusCode", "status"],
    ["statusText", "statusText"],
    ["statusMessage", "statusText"]
  ])
    Object.defineProperty(i, o, {
      get() {
        return e.response && e.response[f];
      }
    });
  return i;
}
const In = new Set(
  Object.freeze(["PATCH", "POST", "PUT", "DELETE"])
);
function Cr(e = "GET") {
  return In.has(e.toUpperCase());
}
function Pn(e) {
  if (e === void 0)
    return !1;
  const t = typeof e;
  return t === "string" || t === "number" || t === "boolean" || t === null ? !0 : t !== "object" ? !1 : Array.isArray(e) ? !0 : e.buffer || e instanceof FormData || e instanceof URLSearchParams ? !1 : e.constructor && e.constructor.name === "Object" || typeof e.toJSON == "function";
}
const Dn = /* @__PURE__ */ new Set([
  "image/svg",
  "application/xml",
  "application/xhtml",
  "application/html"
]), _n = /^application\/(?:[\w!#$%&*.^`~-]*\+)?json(;.+)?$/i;
function Tn(e = "") {
  if (!e)
    return "json";
  const t = e.split(";").shift() || "";
  return _n.test(t) ? "json" : t === "text/event-stream" ? "stream" : Dn.has(t) || t.startsWith("text/") ? "text" : "blob";
}
function Nn(e, t, r, a) {
  const n = Cn(
    t?.headers ?? e?.headers,
    r?.headers,
    a
  );
  let s;
  return (r?.query || r?.params || t?.params || t?.query) && (s = {
    ...r?.params,
    ...r?.query,
    ...t?.params,
    ...t?.query
  }), {
    ...r,
    ...t,
    query: s,
    params: s,
    headers: n
  };
}
function Cn(e, t, r) {
  if (!t)
    return new r(e);
  const a = new r(t);
  if (e)
    for (const [n, s] of Symbol.iterator in e || Array.isArray(e) ? e : new r(e))
      a.set(n, s);
  return a;
}
async function jt(e, t) {
  if (t)
    if (Array.isArray(t))
      for (const r of t)
        await r(e);
    else
      await t(e);
}
const Vn = /* @__PURE__ */ new Set([
  408,
  // Request Timeout
  409,
  // Conflict
  425,
  // Too Early (Experimental)
  429,
  // Too Many Requests
  500,
  // Internal Server Error
  502,
  // Bad Gateway
  503,
  // Service Unavailable
  504
  // Gateway Timeout
]), Fn = /* @__PURE__ */ new Set([101, 204, 205, 304]);
function ua(e = {}) {
  const {
    fetch: t = globalThis.fetch,
    Headers: r = globalThis.Headers,
    AbortController: a = globalThis.AbortController
  } = e;
  async function n(i) {
    const o = i.error && i.error.name === "AbortError" && !i.options.timeout || !1;
    if (i.options.retry !== !1 && !o) {
      let u;
      typeof i.options.retry == "number" ? u = i.options.retry : u = Cr(i.options.method) ? 0 : 1;
      const m = i.response && i.response.status || 500;
      if (u > 0 && (Array.isArray(i.options.retryStatusCodes) ? i.options.retryStatusCodes.includes(m) : Vn.has(m))) {
        const h = typeof i.options.retryDelay == "function" ? i.options.retryDelay(i) : i.options.retryDelay || 0;
        return h > 0 && await new Promise((O) => setTimeout(O, h)), s(i.request, {
          ...i.options,
          retry: u - 1
        });
      }
    }
    const f = xn(i);
    throw Error.captureStackTrace && Error.captureStackTrace(f, s), f;
  }
  const s = async function(o, f = {}) {
    const u = {
      request: o,
      options: Nn(
        o,
        f,
        e.defaults,
        r
      ),
      response: void 0,
      error: void 0
    };
    if (u.options.method && (u.options.method = u.options.method.toUpperCase()), u.options.onRequest && (await jt(u, u.options.onRequest), u.options.headers instanceof r || (u.options.headers = new r(
      u.options.headers || {}
      /* compat */
    ))), typeof u.request == "string" && (u.options.baseURL && (u.request = En(u.request, u.options.baseURL)), u.options.query && (u.request = On(u.request, u.options.query), delete u.options.query), "query" in u.options && delete u.options.query, "params" in u.options && delete u.options.params), u.options.body && Cr(u.options.method))
      if (Pn(u.options.body)) {
        const O = u.options.headers.get("content-type");
        typeof u.options.body != "string" && (u.options.body = O === "application/x-www-form-urlencoded" ? new URLSearchParams(
          u.options.body
        ).toString() : JSON.stringify(u.options.body)), O || u.options.headers.set("content-type", "application/json"), u.options.headers.has("accept") || u.options.headers.set("accept", "application/json");
      } else // ReadableStream Body
      ("pipeTo" in u.options.body && typeof u.options.body.pipeTo == "function" || // Node.js Stream Body
      typeof u.options.body.pipe == "function") && ("duplex" in u.options || (u.options.duplex = "half"));
    let m;
    if (!u.options.signal && u.options.timeout) {
      const O = new a();
      m = setTimeout(() => {
        const R = new Error(
          "[TimeoutError]: The operation was aborted due to timeout"
        );
        R.name = "TimeoutError", R.code = 23, O.abort(R);
      }, u.options.timeout), u.options.signal = O.signal;
    }
    try {
      u.response = await t(
        u.request,
        u.options
      );
    } catch (O) {
      return u.error = O, u.options.onRequestError && await jt(
        u,
        u.options.onRequestError
      ), await n(u);
    } finally {
      m && clearTimeout(m);
    }
    if ((u.response.body || // https://github.com/unjs/ofetch/issues/324
    // https://github.com/unjs/ofetch/issues/294
    // https://github.com/JakeChampion/fetch/issues/1454
    u.response._bodyInit) && !Fn.has(u.response.status) && u.options.method !== "HEAD") {
      const O = (u.options.parseResponse ? "json" : u.options.responseType) || Tn(u.response.headers.get("content-type") || "");
      switch (O) {
        case "json": {
          const R = await u.response.text(), p = u.options.parseResponse || Pt;
          u.response._data = p(R);
          break;
        }
        case "stream": {
          u.response._data = u.response.body || u.response._bodyInit;
          break;
        }
        default:
          u.response._data = await u.response[O]();
      }
    }
    return u.options.onResponse && await jt(
      u,
      u.options.onResponse
    ), !u.options.ignoreResponseError && u.response.status >= 400 && u.response.status < 600 ? (u.options.onResponseError && await jt(
      u,
      u.options.onResponseError
    ), await n(u)) : u.response;
  }, l = async function(o, f) {
    return (await s(o, f))._data;
  };
  return l.raw = s, l.native = (...i) => t(...i), l.create = (i = {}, o = {}) => ua({
    ...e,
    ...o,
    defaults: {
      ...e.defaults,
      ...o.defaults,
      ...i
    }
  }), l;
}
const _t = (function() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("unable to locate global object");
})(), Ln = _t.fetch ? (...e) => _t.fetch(...e) : () => Promise.reject(new Error("[ofetch] global.fetch is not supported!")), Mn = _t.Headers, qn = _t.AbortController, Un = ua({ fetch: Ln, Headers: Mn, AbortController: qn });
function nt(e, t, r) {
  return e ? /* @__PURE__ */ cr(t, r) : /* @__PURE__ */ Dt(t, "Dit veld is verplicht");
}
const Wn = /* @__PURE__ */ ae(
  /* @__PURE__ */ Te(),
  /* @__PURE__ */ lt((e) => {
    if (e = e.replace(/[^0-9+]/g, ""), e = e.replace(/^.+\+/g, ""), e != "")
      return e[0] == "+" ? e : `+31${e.substring(1, 10)}`;
  }),
  /* @__PURE__ */ Te(),
  /* @__PURE__ */ ht(/^\+[0-9]{11}$/)
), kt = /* @__PURE__ */ fr([
  /* @__PURE__ */ ae(
    /* @__PURE__ */ Te(),
    /* @__PURE__ */ Ue(),
    /* @__PURE__ */ He(""),
    /* @__PURE__ */ lt(() => {
    })
  ),
  /* @__PURE__ */ Te(),
  // Pass strings not matching above transform as is
  /* @__PURE__ */ na()
  // Pass undefined as is
]);
function zn(e) {
  return e?.constructor?.name == "File";
}
function ie(e) {
  return e && (e instanceof Date || e.constructor.name == "File" || e.constructor.name == "FileList") ? !1 : typeof e == "object" && !!e && !Array.isArray(e);
}
function Tt(e, t, r) {
  if (!e) return r;
  var a, n;
  if (Array.isArray(t) && (a = t.slice(0)), typeof t == "string" && (a = t.split(".")), typeof t == "symbol" && (a = [t]), !Array.isArray(a)) throw Error("props arg must be an array, a string or a symbol");
  for (; a.length; ) if (n = a.shift(), !e || !n || (e = e[n], e === void 0)) return r;
  return e;
}
function Gn(e) {
  let t = String(e);
  return t === "__proto__" || t === "constructor" || t === "prototype";
}
const tr = /^\d+$/;
function Hn(e, t, r) {
  if (r !== void 0 && ie(r)) {
    let a = e.join("."), n = a ? Tt(r, a) : r;
    if (n !== void 0) return Array.isArray(n);
  }
  return tr.test(t);
}
function Bn(e, t) {
  if (!e) return {};
  let r = {}, a = Object.entries(e).sort((n, s) => s[0].split(".").length - n[0].split(".").length);
  for (let [n, s] of a) {
    let l = n.split("."), i = r;
    for (let o = 0; o < l.length; o++) {
      let f = l[o];
      if (Gn(f)) break;
      let u = o === l.length - 1, m = tr.test(f), h = Array.isArray(i) && m ? Number(f) : null, O = l[o + 1], R = l.slice(0, o + 1);
      if (h !== null) {
        if (Array.isArray(i))
          if (u) {
            let p = i[h];
            if (typeof p == "object" && p && !Array.isArray(p)) p.$self = s;
            else {
              let w = t !== void 0 && ie(t) ? Tt(t, R.join(".")) : void 0, S = w !== void 0 && ie(w) && !Array.isArray(w);
              i[h] = S ? { $self: s } : s;
            }
          } else (typeof i[h] != "object" || i[h] === null) && (i[h] = O && tr.test(O) ? { $each: [], $self: [] } : {}), i = "$each" in i[h] ? i[h].$each : i[h];
      } else if (u) {
        let p = t !== void 0 && ie(t) && Array.isArray(Tt(t, R.join(".")));
        typeof i[f] == "object" && i[f] !== null && !Array.isArray(i[f]) ? i[f].$self = s : p && Array.isArray(s) ? i[f] = { $self: s } : i[f] = s;
      } else {
        let p = Hn(R, O, t);
        if (Array.isArray(i[f])) {
          let w = i[f].slice();
          i[f] = p ? { $each: [], $self: w } : { $self: w };
        }
        (typeof i[f] != "object" || i[f] === null) && (i[f] = p ? { $each: [], $self: [] } : {}), i = p && "$each" in i[f] ? i[f].$each : i[f];
      }
    }
  }
  return r;
}
function Jn(e, t) {
  let r = !1, a = { ...e };
  for (let n of Object.keys(a)) {
    let s = a[n];
    if (Array.isArray(s) && s.length > 0 && typeof s[0] == "string") {
      let l = Tt(t, n);
      Array.isArray(l) && (a[n] = { $self: s }, r = !0);
    }
  }
  return r ? a : e;
}
function rr(e, t) {
  if (!e || !ie(e)) return e;
  let r = e;
  return Object.keys(e).some((a) => a.includes(".")) && (r = Bn(e, t)), t !== void 0 && ie(t) && (r = Jn(r, t)), r;
}
function Kn(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function Ce(e, t = !0, r = !0) {
  return e == null ? !0 : e instanceof Date ? isNaN(e.getTime()) : zn(e) ? e.size <= 0 : Array.isArray(e) ? t ? e.length === 0 : !1 : ie(e) ? e == null ? !0 : r ? Object.keys(e).length === 0 : !1 : !String(e).length;
}
function Yn(e) {
  let t = [];
  return e.global && t.push("g"), e.ignoreCase && t.push("i"), e.multiline && t.push("m"), e.sticky && t.push("y"), e.unicode && t.push("u"), t.join("");
}
function ue(e, t = 0) {
  if (t > 20) return e;
  let r = e, a = {}.toString.call(e).slice(8, -1);
  if (a == "Set" && (r = new Set([...e].map((n) => ue(n, t + 1)))), a == "Map" && (r = new Map([...e].map((n) => [ue(n[0], t + 1), ue(n[1], t + 1)]))), a == "Date" && (r = new Date(e.getTime())), a == "RegExp" && (r = RegExp(e.source, Yn(e))), a == "Array" || a == "Object") {
    r = Array.isArray(e) ? [] : {};
    for (let n in e) r[n] = ue(e[n], t + 1);
  }
  return r;
}
function Vr(e) {
  let t = Object.prototype.toString.call(e);
  return e == null ? /* @__PURE__ */ new Date(NaN) : e instanceof Date || typeof e == "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function Fr(e, t, { immediate: r = !1, trackDebounceRef: a } = {}) {
  let n, s = [];
  function l() {
    a && (a.value = !1);
  }
  function i(m) {
    let h = s;
    s = [], h.forEach(m);
  }
  function o(m) {
    i((h) => h.resolve(m)), l();
  }
  function f(m) {
    i((h) => h.reject(m)), l();
  }
  let u = (...m) => (a && (a.value = !0), new Promise((h, O) => {
    if (s.push({ resolve: h, reject: O }), clearTimeout(n), n = setTimeout(() => {
      if (l(), n = void 0, !r) try {
        Promise.resolve(e.apply(this, [...m])).then(o).catch(f).finally(l);
      } catch (R) {
        f(R);
      }
    }, t), r) {
      l();
      try {
        Promise.resolve(e.apply(this, [...m])).then(o).catch(f).finally(l);
      } catch (R) {
        f(R);
      }
    }
  }));
  return u.cancel = () => {
    clearTimeout(n), n = void 0, o(void 0);
  }, u;
}
function ar(e, t, r = !1, a = !0) {
  if (e === t) return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor) return !1;
    var n, s, l;
    if (Array.isArray(e) && Array.isArray(t)) {
      if (n = e.length, n != t.length) return !1;
      if (a || !a && r) {
        for (s = n; s-- !== 0; ) if (!ar(e[s], t[s], r, !1)) return !1;
      }
      return !0;
    }
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
    if (l = Object.keys(e), n = l.length, n !== Object.keys(t).length) return !1;
    for (s = n; s-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(t, l[s])) return !1;
    for (s = n; s-- !== 0; ) {
      var i = l[s];
      if (ie(e) && ie(t) && i && (a || !a && r) && !ar(e[i], t[i], r, !1)) return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
var Wt = class extends Error {
  constructor(e = "Promise was aborted") {
    super(e), this.name = "AbortError";
  }
};
function Qn(e) {
  let t = new AbortController(), { signal: r } = t, a = new Promise((s, l) => {
    function i() {
      l(new Wt());
    }
    r.addEventListener("abort", i), e.then((o) => {
      r.removeEventListener("abort", i), r.aborted ? l(new Wt()) : s(o);
    }).catch((o) => {
      r.removeEventListener("abort", i), r.aborted ? l(new Wt()) : l(o);
    });
  });
  function n(s) {
    t.abort(s);
  }
  return { promise: a, abort: n, signal: r };
}
function Zn(e, t, r) {
  if (!xe(e)) return r?.(), me(e);
  let a = I(!1);
  st() && sr(async () => {
    await Ze(), typeof window < "u" && window.requestAnimationFrame(() => {
      a.value = !0;
    });
  });
  let n = {}, s = new Proxy(n, { get(l, i, o) {
    if (r?.(), Reflect.getOwnPropertyDescriptor(n, i) || t.value && i !== "$value" && a.value) return Reflect.get(n, i, o);
    if (e.value !== void 0) return We(Reflect.get(e.value, i, o));
  }, set(l, i, o) {
    return r?.(), Reflect.getOwnPropertyDescriptor(n, i) ? Reflect.set(n, i, o) : (xe(e.value[i]) && !xe(o) ? e.value[i].value = o : e.value[i] = o, !0);
  }, deleteProperty(l, i) {
    return r?.(), Reflect.getOwnPropertyDescriptor(n, i) ? Reflect.deleteProperty(n, i) : Reflect.deleteProperty(e.value, i);
  }, has(l, i) {
    return r?.(), Reflect.has(n, i) ? !0 : e.value !== void 0 && Reflect.has(e.value, i);
  }, ownKeys() {
    r?.();
    let l = e.value === void 0 ? [] : Object.keys(e.value);
    return [.../* @__PURE__ */ new Set([...l, ...Reflect.ownKeys(n)])];
  }, getOwnPropertyDescriptor(l, i) {
    r?.();
    let o = Reflect.getOwnPropertyDescriptor(n, i);
    if (o) return o;
    if (!(e.value === void 0 || !Reflect.has(e.value, i))) return { enumerable: !0, configurable: !0, get: () => We(Reflect.get(e.value, i)), set: (f) => {
      xe(e.value[i]) && !xe(f) ? e.value[i].value = f : e.value[i] = f;
    } };
  }, defineProperty(l, i, o) {
    return r?.(), Reflect.defineProperty(n, i, o);
  } });
  return me(s);
}
function nr(e) {
  try {
    return e.map((t) => P(t));
  } catch {
    return [];
  }
}
function dr(e) {
  return ie(e.value);
}
function Lr(e, t, r) {
  let a = ye(), n;
  return n = e instanceof Function ? a.run(() => ({ computedEach: v(() => e(t, r ?? 0)) })).computedEach : e, { scope: a, unwrapped: n };
}
const pt = { LessThan: -1, EqualTo: 0, GreaterThan: 1 };
function Xn(e, t) {
  let r = String(e).split("."), a = String(t).split(".");
  for (let n = 0; n < Math.min(r.length, a.length); n++) {
    let s = Number(r[n]), l = Number(a[n]);
    if (s > l) return pt.GreaterThan;
    if (l > s) return pt.LessThan;
    if (!isNaN(s) && isNaN(l)) return pt.GreaterThan;
    if (isNaN(s) && !isNaN(l)) return pt.LessThan;
  }
  return pt.EqualTo;
}
const pr = Xn(ka, "3.5.0") !== -1;
function el() {
  return Math.floor(Math.random() * Date.now()).toString();
}
function yr() {
  return typeof window > "u" ? el() : window.crypto.getRandomValues(new Uint32Array(1))[0].toString(10);
}
function $r(e) {
  return Ft() ? (Lt(e), !0) : !1;
}
function tl(e, t) {
  return e.some((r) => t ? r?.[t] : !1);
}
function rl(e, t) {
  return t ? e.reduce((r, a) => {
    let n = a?.[t] || [];
    return r.concat(n);
  }, []) : [];
}
const Mr = { INSPECTOR: "regle-inspector" }, al = /* @__PURE__ */ Symbol("regle"), oa = /* @__PURE__ */ Symbol("regle-config"), qr = { REGLE_STATIC: "__regle_static" };
function ca() {
  return !!(typeof globalThis < "u" && ("__vitest_worker__" in globalThis || "__JEST_GLOBAL__" in globalThis || typeof window < "u" && "Cypress" in window || typeof process < "u" && process.env && (process.env.VITEST || process.env.JEST_WORKER_ID || process.env.NODE_ENV === "test" || process.env.PLAYWRIGHT_TEST)));
}
function nl() {
  let e = I(!1), t = _e(), r = _e(/* @__PURE__ */ new Map()), a = _e(/* @__PURE__ */ new Map()), n = _e(/* @__PURE__ */ new Map()), s = I(0), l;
  function i(p) {
    t.value = p;
  }
  function o(p, w) {
    let S = w?.filePath ?? "loose", M = n.value.get(S), F = M ? M + 1 : 1;
    n.value.set(S, F);
    let q = `${w?.uid?.toString() ?? "regle"}#${++s.value}`, d = `r$ #${w?.name ?? F}`;
    r.value.set(q, { id: q, name: d, r$: p, componentName: w?.componentName, filePath: w?.filePath });
    let C = le([() => p.$value, () => p.$externalErrors, () => p.$externalIssues, () => p.$error, () => p.$invalid, () => p.$pending], () => u(), { deep: !0, flush: "post" });
    return a.value.set(q, C), window.requestAnimationFrame(() => {
      f();
    }), q;
  }
  function f() {
    t.value && ul(t.value);
  }
  function u() {
    l ??= window.requestAnimationFrame(() => {
      l = void 0, f();
    });
  }
  function m(p) {
    let w = a.value.get(p);
    w && (w(), a.value.delete(p)), r.value.delete(p), f();
  }
  function h() {
    return Array.from(r.value.values());
  }
  function O(p) {
    return r.value.get(p);
  }
  function R() {
    a.value.forEach((p) => p()), a.value.clear(), r.value.clear(), f();
  }
  return { devtoolsApi: t, register: o, unregister: m, getAll: h, get: O, clear: R, setApi: i, notifyDevtools: f, loggedWarning: e };
}
const yt = nl();
function ll(e, t) {
  if (typeof window > "u" || !(typeof __VUE_PROD_DEVTOOLS__ < "u" && __VUE_PROD_DEVTOOLS__) || ca()) return () => {
  };
  if (!ur(al, void 0) && !yt.loggedWarning.value && yt.devtoolsApi) return yt.loggedWarning.value = !0, console.warn("📏 Regle Devtools are not available. Install Regle plugin in your app to enable them. https://reglejs.dev/introduction/devtools"), () => {
  };
  let r = st(), a = r?.type?.name || r?.type?.__name, n;
  r && r.type && typeof r.type == "object" && "__file" in r.type && (n = r.type.__file);
  let s = yt.register(e, { name: t?.name, componentName: a, uid: r?.uid, filePath: n });
  function l() {
    yt.unregister(s);
  }
  return $r(l), l;
}
function fa(e, t) {
  return !Xe(e.value) && (dr(e) || ie(t.value) && !Ce(t.value) && !Object.entries(t.value).some(([r, a]) => mt(a) || typeof a == "function"));
}
function il(e, t) {
  return !!e.value && ie(e.value) && "$each" in e.value || Array.isArray(t.value);
}
function va(e) {
  return !!e.value && (ie(e.value) || dr(e.value));
}
function mt(e) {
  return (ie(e) || typeof e == "function") && "_validator" in e;
}
function Rt(e) {
  return typeof e.value != "function" || "_validator" in e.value;
}
function Xe(e) {
  return ie(e) && Kn(e, qr.REGLE_STATIC) && e[qr.REGLE_STATIC] === !0;
}
function da(e) {
  return ie(e) && "$fields" in e;
}
function sl(e) {
  return !!e && "$each" in e;
}
function lr(e) {
  return !!e && "$rules" in e;
}
async function ul(e) {
  e.sendInspectorTree(Mr.INSPECTOR), e.sendInspectorState(Mr.INSPECTOR);
}
function ol() {
  let e = _e(/* @__PURE__ */ new Map()), t = _e(/* @__PURE__ */ new Map()), r = _e(/* @__PURE__ */ new Map()), a = _e(/* @__PURE__ */ new Map()), n = _e(/* @__PURE__ */ new Map()), s = _e(/* @__PURE__ */ new Map()), l = _e(/* @__PURE__ */ new Map());
  function i(d) {
    let C = t.value.get(d);
    if (C) return C;
    {
      let N = I({});
      return t.value.set(d, N), N;
    }
  }
  function o(d) {
    let C = r.value.get(d);
    if (C) return C;
    {
      let N = I([]);
      return r.value.set(d, N), N;
    }
  }
  function f(d, C) {
    s.value.set(d, C);
  }
  function u(d) {
    return s.value.get(d);
  }
  function m(d, C, N) {
    l.value.set(`${d}-${C}`, N);
  }
  function h(d, C) {
    return l.value.get(`${d}-${C}`);
  }
  function O(d, C) {
    d && C != null && l.value.delete(`${d}-${C}`);
  }
  function R(d, C) {
    a.value.set(d, C);
  }
  function p(d) {
    return a.value.get(d) ?? !1;
  }
  function w(d, C) {
    e.value.set(d, C);
  }
  function S(d, C) {
    let N = e.value.get(d);
    if (N) return M(C, N) ? { valid: !0 } : { valid: !1 };
  }
  function M(d, C) {
    let N = Object.keys(C), T = Object.keys(d);
    return T.length !== N.length || !T.every((z) => N.includes(z)) ? !1 : T.every((z) => {
      let k = d[z], $ = C[z];
      if (!$ || !k || typeof k == "function" || typeof $ == "function" || typeof k == "number" || typeof k == "boolean" || typeof k == "string") return !1;
      if ("_params" in k) {
        if (!k._params) return !0;
        if (Array.isArray(k._params)) return k._params?.every((G, Y) => {
          if (typeof $ == "number" || typeof $ == "boolean" || typeof $ == "string") return !0;
          {
            let te = nr("_params" in $ && Array.isArray($._params) ? $._params : []), g = nr(k._params);
            return te?.[Y] === g?.[Y];
          }
        });
      }
    });
  }
  function F(d) {
    let C = n.value.get(d);
    if (C) return C;
    {
      let N = I(!1), T = I(!0), z = I({}), k = I(!1);
      return n.value.set(d, { $pending: N, $valid: T, $metadata: z, $validating: k }), { $pending: N, $valid: T, $metadata: z, $validating: k };
    }
  }
  function q() {
    e.value.clear(), t.value.clear(), r.value.clear(), a.value.clear(), n.value.clear(), s.value.clear(), l.value.clear();
  }
  return Ft() && Lt(q), { clearAll: q, addRuleDeclEntry: w, setDirtyEntry: R, checkRuleDeclEntry: S, getDirtyState: p, trySetRuleStatusRef: F, getFieldsEntry: i, getCollectionsEntry: o, getArrayStatus: h, addArrayStatus: m, deleteArrayStatus: O, arrayStatusStorage: l, addAdditionalRulesEntry: f, getAdditionalRulesEntry: u };
}
function Ur({ field: e, silent: t = !1 }) {
  let r = Object.entries(e.$rules ?? {}).map(([l, i]) => {
    let o = "";
    if (t && !i.$valid) o = i.$message;
    else if (!i.$valid && e.$error && !i.$validating) o = i.$message;
    else return null;
    return { $message: o, $property: e.fieldName, $rule: l, $type: i.$type, ...typeof i.$metadata == "object" ? i.$metadata : {} };
  }).filter((l) => !!l).reduce((l, i) => (typeof i.$message == "string" ? l.push(i) : l.push(...i.$message.map((o) => ({ ...i, $message: o }))), l), []), a = e.$error && e.$externalErrors && Array.isArray(e.$externalErrors) && !e.$externalIssues?.length ? e.$externalErrors.map((l) => ({ $message: l, $property: e.fieldName, $rule: "external", $type: void 0 })) : [], n = e.$error && e.$externalIssues && Array.isArray(e.$externalIssues) ? e.$externalIssues.map((l) => ({ ...l, $property: l.$property ?? e.fieldName, $rule: l.$rule ?? "external" })) : [], s = [];
  return e.$schemaErrors && e.$error && (s = !Array.isArray(e.$schemaErrors) && "$self" in e.$schemaErrors ? e.$schemaErrors.$self ?? [] : e.$schemaErrors ?? []), [...r, ...a, ...n, ...s];
}
function cl({ field: e }) {
  let t = [];
  for (let r of Object.values(e.$rules ?? {})) {
    let a = r.$tooltip;
    a && (typeof a == "string" ? t.push(a) : t.push(...a));
  }
  return t;
}
function pa(e) {
  return ie(e) && "$each" in e;
}
function fl(e, t) {
  let { includePath: r = !1 } = t ?? {};
  if (Array.isArray(e) && e.every((a) => !ie(a))) return e;
  if (pa(e)) {
    let a = r ? e.$self?.map((s) => ({ message: s, path: [] })) ?? [] : e.$self ?? [], n = e.$each?.map((s) => Nt(s, r)) ?? [];
    return a?.concat(n.flat());
  }
  return Object.entries(e).map(([a, n]) => Nt(n, r, [a])).flat();
}
function Nt(e, t = !1, r) {
  let a = t && !r ? [] : r;
  if (Array.isArray(e) && e.every((n) => !ie(n))) return t ? e.map((n) => ({ message: n, path: a ?? [] })) : e;
  if (pa(e)) {
    let n = a?.length ? e.$self?.map((l) => ({ message: l, path: a ?? [] })) ?? [] : e.$self ?? [], s = e.$each?.map((l, i) => Nt(l, t, a?.concat(i))) ?? [];
    return n?.concat(s.flat());
  }
  return Object.entries(e).map(([n, s]) => Nt(s, t, a?.concat(n))).flat();
}
function vl({ customMessages: e, rule: t, ruleKey: r, state: a, path: n, cachePath: s, storage: l, modifiers: i }) {
  let o = ye(), f = {}, u, m = v(() => mt(t.value) && t.value._async), h = I(!1), O = 0, { $pending: R, $valid: p, $metadata: w, $validating: S } = l.trySetRuleStatusRef(`${s}.${r}`);
  function M() {
    o = ye(), f = o.run(() => {
      let k = I(!1), $ = I(!1), G = I(!0), Y = I(!1), te = I(!1), g = v(() => ({ $value: a.value, $error: $.value, $dirty: k.value, $pending: Y.value, $correct: te.value, $invalid: G.value, $rule: { $valid: p.value, $invalid: !p.value, $pending: R.value }, $params: ne.value, ...w.value })), A = v(() => {
        try {
          return Rt(t) ? typeof t.value.active == "function" ? t.value.active(g.value) : !!t.value.active : !0;
        } catch (oe) {
          return console.error(`Error in "active" function for "${n}.${r}" rule`, { cause: oe }), !0;
        }
      });
      function J(oe) {
        try {
          let Pe = "", we = e ? e[r]?.[oe] : void 0;
          if (we && (Pe = typeof we == "function" ? we(g.value) : we), Rt(t)) {
            let he = `_${oe}_patched`;
            we && !t.value[he] || (Pe = typeof t.value[oe] == "function" ? t.value[oe](g.value) : t.value[oe] ?? "");
          }
          return Pe;
        } catch (Pe) {
          return console.error(`Error in "${oe}" function for "${n}.${r}" rule`, { cause: Pe }), "";
        }
      }
      let de = v(() => {
        let oe = J("message");
        return Ce(oe) && (oe = "This field is not valid"), oe;
      }), Se = v(() => J("tooltip")), X = v(() => Rt(t) && t.value.type ? t.value.type : r), Ie = v(() => Rt(t) ? t.value.validator : t.value), ne = v(() => typeof t.value == "function" ? [] : nr(t.value._params ?? []));
      return { $active: A, $message: de, $type: X, $validator: Ie, $params: ne, $path: v(() => `${n}.${r}`), $tooltip: Se, $fieldCorrect: te, $fieldError: $, $fieldDirty: k, $fieldPending: Y, $fieldInvalid: G };
    }), u = le(f?.$params, () => {
      (!i.$silent.value || i.$rewardEarly.value && f.$fieldError.value) && C();
    }, { deep: !pr || 1 });
  }
  M();
  function F() {
    p.value = !0, f.$fieldDirty.value && (R.value = !0);
  }
  async function q(k) {
    let $ = !1;
    try {
      let G = f.$validator.value;
      if (typeof G != "function") return console.error(`${n}: Incorrect rule format, it needs to be either a function or created with "createRule".`), !1;
      let Y = G(a.value, ...f.$params.value), te = a.value;
      F();
      let g;
      if (g = Y instanceof Promise ? await Y : Y, k !== O || a.value !== te) return p.value;
      if (typeof g == "boolean") $ = g;
      else {
        let { $valid: A, ...J } = g;
        $ = A, w.value = J;
      }
    } catch {
      $ = !1;
    } finally {
      k === O && (R.value = !1);
    }
    return $;
  }
  function d(k, $ = !0) {
    if (mt(t.value) && t.value._async) return !0;
    let G = k(a.value, ...f.$params.value);
    if (G instanceof Promise) return !0;
    if (G != null) {
      if (typeof G == "boolean") return G;
      {
        let { $valid: Y, ...te } = G;
        return w.value = te, Y;
      }
    }
    return !0;
  }
  async function C() {
    let k = ++O;
    try {
      S.value = !0;
      let $ = !1;
      if (h.value = !0, mt(t.value) && t.value._async) $ = await q(k);
      else {
        let G = f.$validator.value;
        $ = d(G);
      }
      return k === O ? (p.value = $, $) : p.value;
    } catch {
      return !1;
    } finally {
      k === O && (S.value = !1, h.value = !1);
    }
  }
  function N() {
    try {
      return S.value = !0, d(f.$validator.value);
    } catch {
      return !1;
    } finally {
      S.value = !1;
    }
  }
  function T() {
    O++, p.value = !0, w.value = {}, R.value = !1, S.value = !1, M();
  }
  function z() {
    u(), o.stop(), o = ye();
  }
  return me({ ...f, $pending: R, $valid: p, $metadata: w, $haveAsync: m, $maybePending: h, $validating: S, $parse: C, $parseSync: N, $unwatch: z, $watch: M, $reset: T });
}
function mr(e) {
  return { "~standard": { version: 1, vendor: "regle", validate: async (t) => {
    let { valid: r, data: a, errors: n } = await e(t, !0);
    return r ? { value: a, issues: [] } : { issues: fl(n, { includePath: !0 }) };
  } } };
}
function gt(e) {
  return e === !0 ? "eager" : e === !1 || e == null ? !1 : e;
}
function bt(e) {
  return ie(e) && !Xe(e) ? Object.values(e).some((t) => bt(t)) : Array.isArray(e) ? e.some((t) => bt(t)) : !Ce(e);
}
function Ct(e, t) {
  return lr(e) ? !e.$inactive && bt(t) : da(e) ? ya(e.$self, e.$fields, t) : sl(e) && Array.isArray(t) ? e.$self && Ct(e.$self, t) ? !0 : e.$each.some((r, a) => Ct(r, t[a])) : !1;
}
function ya(e, t, r) {
  if (e && Ct(e, r)) return !0;
  if (!ie(r) || Xe(r)) return !1;
  let a = r;
  return Object.entries(t).some(([n, s]) => Ct(s, a[n]));
}
function dl(e, t, r, a = !1, n = !1) {
  return e === "eager" ? !0 : e === "non-empty" ? !a || n ? !1 : bt(r) : e === "lazy-non-empty" && bt(t);
}
function Mt({ state: e, rulesDef: t, customMessages: r, path: a, cachePath: n, fieldName: s, storage: l, options: i, externalErrors: o, externalIssues: f, schemaErrors: u, schemaMode: m, onUnwatch: h, $isArray: O, initialState: R, rootInitialState: p, originalState: w, shortcuts: S, overrides: M, onValidate: F }) {
  let q = ye(), d, C = [], N, T, z, k, $ = () => {
  }, G, Y = () => {
  }, te = I(!1), g = I(l.getAdditionalRulesEntry(n) ?? {});
  function A(x) {
    g.value = x ?? {}, l.addAdditionalRulesEntry(n, x ?? {}), de(), $();
  }
  function J(x) {
    A(x);
  }
  function de() {
    let x = { ...t.value, ...g.value }, ee = [];
    for (let V in x) {
      if (V.startsWith("$") || V.startsWith("~")) continue;
      let Oe = x[V];
      if (!Oe) continue;
      let ke = K(() => Oe);
      ee.push([V, vl({ modifiers: { $silent: d.$silent, $rewardEarly: d.$rewardEarly }, customMessages: r, rule: ke, ruleKey: V, state: e, path: a, cachePath: n, storage: l, $debounce: E.value.$debounce })]);
    }
    c.value = Object.fromEntries(ee), l.addRuleDeclEntry(n, x);
  }
  function Se() {
    let x = { ...t.value, ...g.value }, ee = l.checkRuleDeclEntry(n, x), V = {};
    for (let Oe in x) Oe.startsWith("$") && (V[Oe] = x[Oe]);
    return E.value = V, ee;
  }
  function X() {
    let x = Se();
    Pe(), de(), d.processShortcuts(), Ie(), ne(), x?.valid != null && (d.$dirty.value = l.getDirtyState(n), (d.$dirty.value && !d.$silent.value || d.$rewardEarly.value && d.$error.value) && $()), l.addRuleDeclEntry(n, t.value);
  }
  function Ie() {
    $ = d.$debounce.value > 0 ? Fr(he, d.$debounce.value, { trackDebounceRef: te }) : he;
  }
  function ne() {
    Y = d.$debounce.value > 0 ? Fr(() => {
      d.$dirty.value = !0;
    }, d.$debounce.value) : () => {
      d.$dirty.value = !0;
    };
  }
  function oe() {
    if (c.value) for (let x of Object.values(c.value)) x.$unwatch();
    T(), k?.(), d.$dirty.value && l.setDirtyEntry(n, d.$dirty.value), N?.(), q.stop(), q = ye();
    for (let x of C) x.stop();
    C = [], h?.(), z?.();
  }
  function Pe() {
    if (c.value) for (let x of Object.values(c.value)) x.$watch();
    d = q.run(() => {
      let x = I(!1), ee = I(!1), V = v(() => x.value), Oe = v(() => O || Xe(e.value)), ke = v(() => E.value.$debounce == null ? P(i.debounce) == null ? d.$haveAnyAsyncRule.value ? 200 : 0 : P(i.debounce) : E.value.$debounce), tt = v(() => E.value.$deepCompare != null && E.value.$deepCompare), Et = v(() => E.value.$lazy == null ? P(i.lazy) != null && P(i.lazy) === !0 : E.value.$lazy), ft = v(() => E.value.$immediateDirty == null ? P(i.immediateDirty) != null && gt(P(i.immediateDirty)) : gt(E.value.$immediateDirty)), U = v(() => E.value.$rewardEarly == null ? P(i.rewardEarly) != null && P(i.rewardEarly) === !0 : !!E.value.$rewardEarly), Q = v(() => E.value.$clearExternalErrorsOnChange == null ? P(i.clearExternalErrorsOnChange) == null ? !De.value : P(i.clearExternalErrorsOnChange) === !0 : !!E.value.$clearExternalErrorsOnChange), pe = v(() => E.value.$clearExternalErrorsOnValidate == null ? P(i.clearExternalErrorsOnValidate) != null && P(i.clearExternalErrorsOnValidate) === !0 : !!E.value.$clearExternalErrorsOnValidate), De = v(() => U.value ? !0 : E.value.$silent == null ? P(i.silent) != null && P(i.silent) === !0 : E.value.$silent), ze = v(() => E.value.$autoDirty == null ? P(i.autoDirty) == null || P(i.autoDirty) === !0 : E.value.$autoDirty), Re = v(() => {
        if (E.value.$isEdited != null) return E.value.$isEdited;
        if (M?.isEdited != null) return M.isEdited;
      }), hr = v(() => {
        for (let Z of Object.values(c.value)) if (Z.$validating) return !0;
        return !1;
      }), gr = v({ get: () => e.value, set(Z) {
        N(), e.value = Z, we();
      } }), Ot = v(() => te.value ? dt.value && x.value : dt.value && !vt.value && x.value), br = v(() => Ur({ field: { $rules: c.value, $error: Ot.value, $externalErrors: o?.value, $externalIssues: f?.value, $schemaErrors: u?.value, fieldName: At.value } })), Er = v(() => Ur({ field: { $rules: c.value, $error: Ot.value, $externalErrors: o?.value, $externalIssues: f?.value, $schemaErrors: u?.value, fieldName: At.value }, silent: !0 })), Or = v(() => br.value.map((Z) => Z.$message)), Ar = v(() => Er.value.map((Z) => Z.$message)), rt = I(!1);
      function Sr(Z, $e) {
        return $e instanceof Date && Z instanceof Date ? Vr($e).getTime() !== Vr(Z).getTime() : $e == null ? typeof Z == "boolean" ? $e === void 0 ? Z === !0 : Z != null : Z != null && Z !== "" : Array.isArray(Z) && Array.isArray($e) ? !ar(Z, $e, E.value.$deepCompare) : $e !== Z;
      }
      Qe(() => {
        x.value ? Re.value ? rt.value = Re.value(e.value, R.value, Sr) : rt.value = Sr(e.value, R.value) : rt.value = !1;
      });
      let wr = v(() => rt.value), jr = v(() => cl({ field: { $rules: c.value } })), kr = v(() => !(dt.value || vt.value)), vt = v(() => ee.value || !U.value ? Object.entries(c.value).some(([Z, $e]) => $e.$pending) : !1), dt = v(() => o?.value?.length || f?.value?.length || u?.value?.length ? !0 : !St.value && Object.values(c.value).some((Z) => !Z.$valid || Z.$maybePending)), At = v(() => s ?? i.id ?? "root"), St = v(() => !m && !Object.keys(c.value).some((Z) => !Z.startsWith("$"))), Rr = v(() => {
        if (o?.value?.length || f?.value?.length || St.value || te.value) return !1;
        if (x.value && !Ce(e.value) && !hr.value && !vt.value) {
          if (m) return !u?.value?.length;
          {
            let Z = Object.values(c.value);
            for (let $e of Z) if ($e.$active && !$e.$valid) return !1;
            return Z.some(($e) => $e.$active);
          }
        }
        return !1;
      }), Ea = v(() => Object.values(c.value).some((Z) => Z.$haveAsync)), Oa = v(() => ({ $debounce: ke.value, $lazy: Et.value, $rewardEarly: U.value, $autoDirty: ze.value, $silent: De.value, $clearExternalErrorsOnChange: Q.value, $clearExternalErrorsOnValidate: pe.value, $immediateDirty: ft.value, $isEdited: Re.value, $disabled: P(i.disabled) ?? !1 }));
      function Aa() {
        S?.fields && Object.entries(S.fields).forEach(([Z, $e]) => {
          let Ir = ye();
          xr[Z] = Ir.run(() => {
            let Pr = I();
            return Qe(() => {
              Pr.value = $e(me({ $dirty: x, $externalErrors: o?.value ?? [], $externalIssues: f?.value ?? [], $value: e, $silentValue: gr, $rules: c, $error: Ot, $pending: vt, $invalid: dt, $correct: Rr, $errors: Or, $ready: kr, $silentErrors: Ar, $anyDirty: V, $tooltips: jr, $name: At, $inactive: St, $edited: rt, $anyEdited: wr }));
            }), Pr;
          }), C.push(Ir);
        });
      }
      let xr = {};
      return { $error: Ot, $pending: vt, $invalid: dt, $correct: Rr, $debounce: ke, $deepCompare: tt, $lazy: Et, $immediateDirty: ft, $ready: kr, $issues: br, $silentIssues: Er, $errors: Or, $silentErrors: Ar, $rewardEarly: U, $autoDirty: ze, $silent: De, $clearExternalErrorsOnChange: Q, $clearExternalErrorsOnValidate: pe, $anyDirty: V, $edited: rt, $anyEdited: wr, $name: At, $haveAnyAsyncRule: Ea, $shortcuts: xr, $validating: hr, $tooltips: jr, $dirty: x, processShortcuts: Aa, $silentValue: gr, $inactive: St, $modifiers: Oa, $isArrayOrRegleStatic: Oe };
    }), we(), T = le(d.$dirty, (x) => {
      l.setDirtyEntry(n, x), Object.values(c.value).forEach((ee) => {
        ee.$fieldDirty = x;
      });
    }), k = le([d.$error, d.$correct, d.$invalid, d.$pending], () => {
      Object.values(c.value).forEach((x) => {
        x.$fieldError = d.$error.value, x.$fieldInvalid = d.$invalid.value, x.$fieldPending = d.$pending.value, x.$fieldCorrect = d.$correct.value;
      });
    }), z = le(d.$haveAnyAsyncRule, Ie);
  }
  function we() {
    N = le(e, () => {
      d.$autoDirty.value && !d.$silent.value && (d.$dirty.value || Y()), t.value instanceof Function && X(), (!d.$silent.value || d.$rewardEarly.value && d.$error.value) && $(), d.$clearExternalErrorsOnChange.value && (D(), se());
    }, { deep: d.$isArrayOrRegleStatic.value ? !0 : !pr || 1 });
  }
  async function he() {
    try {
      let { promise: x } = j(Promise.allSettled(Object.values(c.value).map((ee) => ee.$parse())));
      await x;
    } catch {
    }
  }
  let c = I({}), E = I({});
  X();
  function y() {
    dl(d.$immediateDirty.value, R.value, p?.value ?? R.value, a === "", d.$inactive.value) && (d.$dirty.value = !0);
  }
  function _(x, ee) {
    if (H(), d.$dirty.value = !1, l.setDirtyEntry(n, !1), !ee)
      if (x?.toOriginalState) e.value = ue(w), R.value = ue(w);
      else if (x?.toInitialState) e.value = ue(R.value);
      else if (x?.toState) {
        let V;
        V = typeof x?.toState == "function" ? x?.toState() : x?.toState, R.value = ue(V), e.value = ue(V);
      } else R.value = ie(e.value) && !Xe(e.value) ? ue(e.value) : Array.isArray(e.value) ? [...e.value] : e.value;
    if (x?.clearExternalErrors !== !1 && (D(), se()), !ee && !x?.keepValidationState) for (let V of Object.values(c.value)) V.$reset();
    if (!d.$lazy.value && !d.$silent.value && !ee) for (let V of Object.values(c.value)) V.$parse();
    y();
  }
  function H() {
    "cancel" in $ && $.cancel();
  }
  function j(x) {
    return G && G.abort(), G = Qn(x), G;
  }
  function W() {
    H(), G && G.abort();
  }
  function b(x = !0, ee = !1) {
    d.$dirty.value || Y(), ee && x ? (!d.$silent.value || d.$rewardEarly.value && d.$error.value) && (H(), $()) : x && (H(), $());
  }
  async function L(x) {
    return x && (e.value = x), await Ze(), B();
  }
  async function B(x) {
    try {
      if (x && (e.value = x), m) return F ? (b(!1), F()) : { valid: !1, data: e.value, errors: d.$errors.value, issues: d.$issues.value };
      let ee = e.value;
      if (d.$clearExternalErrorsOnValidate.value && (D(), se()), d.$autoDirty.value && !d.$silent.value && d.$dirty.value && !d.$validating.value && !d.$pending.value && !te.value && !Ce(c.value)) return { valid: !d.$invalid.value, data: ee, errors: d.$errors.value, issues: d.$issues.value };
      if (d.$dirty.value || (d.$dirty.value = !0), Ce(c.value)) return { valid: !0, data: ee, errors: d.$errors.value, issues: d.$issues.value };
      W();
      let { promise: V } = j(Promise.allSettled(Object.values(c.value).map((ke) => ke.$parse()))), Oe = await V;
      return await Ze(), { valid: Oe.every((ke) => ke.status === "fulfilled" && ke.value === !0), data: ee, errors: d.$errors.value, issues: d.$issues.value };
    } catch {
      return { valid: !1, data: e.value, errors: d.$errors.value, issues: d.$issues.value };
    }
  }
  function ce(x) {
    try {
      return x && (e.value = x), d.$dirty.value || (d.$dirty.value = !0), !m && (d.$clearExternalErrorsOnValidate.value && (D(), se()), Object.values(c.value).map((ee) => ee.$parseSync()).every((ee) => !!ee));
    } catch {
      return !1;
    }
  }
  function ve(x = !0) {
    return d.$dirty.value ? e.value : x ? { _null: !0 } : null;
  }
  function ge(x) {
    o && (o.value = x), se();
  }
  function D() {
    o?.value?.length && (o.value = []);
  }
  function re(x) {
    f && (f.value = x), D();
  }
  function se() {
    f?.value?.length && (f.value = []);
  }
  !d.$lazy.value && !d.$dirty.value && !d.$silent.value && he(), y();
  let { $shortcuts: be, $validating: je, $autoDirty: Ee, $rewardEarly: Ve, $clearExternalErrorsOnChange: Ne, $clearExternalErrorsOnValidate: Je, $haveAnyAsyncRule: ot, $debounce: ct, $lazy: et, ...Ke } = d, Ye = me({ ...Ke, $externalErrors: o, $externalIssues: f, $value: e, $output: e, $initialValue: R, $originalValue: w, $rules: c, ...be, $path: a, $isDebouncing: te, $reset: _, $touch: b, $validate: L, $validateSync: ce, $validateWithoutRaceconditions: B, $unwatch: oe, $watch: Pe, $extractDirtyFields: ve, $clearExternalErrors: D, $clearExternalIssues: se, $abort: W, $addRules: A, addRules: J, $schemaMode: m, "~modifiers": d.$modifiers, $setExternalErrors: ge, $setExternalIssues: re, ...mr(L) });
  return Object.defineProperty(Ye, /* @__PURE__ */ Symbol.for("regle:instance"), { value: !0 }), Ye;
}
function Wr({ $id: e, path: t, cachePath: r, index: a, options: n, storage: s, stateValue: l, customMessages: i, rules: o, externalErrors: f, externalIssues: u, schemaErrors: m, initialState: h, originalState: O, shortcuts: R, fieldName: p, schemaMode: w, overrides: S, currentIndexes: M }) {
  let F = v(() => P(o)), q = l.value?.$id ?? F.value.$key ?? yr(), d = `${r}.${String(q)}`, C = I(a), N = `${t}.${a}`;
  typeof l.value == "object" && l.value != null && (l.value.$id || Object.defineProperties(l.value, { $id: { value: q, enumerable: !1, configurable: !1, writable: !1 } }));
  let T = $t({ index: a, state: l, rulesDef: F, nestedReactiveRules: !0, customMessages: i, path: N, cachePath: d, storage: s, options: n, externalErrors: K(f?.value ?? [], a), externalIssues: K(u?.value ?? [], a), schemaErrors: v(() => m?.value?.[C.value]), initialState: h, originalState: O, shortcuts: R, fieldName: p, schemaMode: w, overrides: S });
  return T && (T.$id = l.value?.$id ?? String(q), M?.set(T.$id, C), s.addArrayStatus(e, T.$id, T)), l.value && (!ie(l.value) || Xe(l.value)) && w && T?.$touch(), T;
}
function pl({ state: e, rulesDef: t, customMessages: r, path: a, cachePath: n, storage: s, options: l, externalErrors: i, externalIssues: o, schemaErrors: f, schemaMode: u, initialState: m, originalState: h, shortcuts: O, fieldName: R, overrides: p }) {
  let w = ye(), S, M = ye(), F, q = [];
  if (!Array.isArray(e.value) && !t.value.$each) return;
  let d = I(), C = I(e.value), N = I({}), T, z, k = I({}), $ = s.getCollectionsEntry(a), G = /* @__PURE__ */ new Map();
  F = M.run(() => ({ isPrimitiveArray: v(() => e.value?.length ? Array.isArray(e.value) && e.value.length ? e.value.every((j) => typeof j != "object") : t.value.$each && !(t.value.$each instanceof Function) ? Object.values(t.value.$each).every((j) => mt(j) || typeof j == "function") : !1 : !1) })), Y(), J();
  function Y() {
    N.value = Object.fromEntries(Object.entries(t.value).filter(([j]) => j.startsWith("$"))), typeof e.value == "object" && (e.value != null && !e.value?.$id && e.value !== null ? (d.value = yr(), Object.defineProperties(e.value, { $id: { value: d.value, enumerable: !1, configurable: !1, writable: !1 } })) : e.value?.$id && (d.value = e.value.$id)), C.value = k.value.$value, Array.isArray(e.value) && (!F.isPrimitiveArray.value || u) ? $.value = e.value.map((j, W) => {
      let { scope: b, unwrapped: L } = Lr(t.value.$each, K(() => j), W);
      b && q.push(b);
      let B = K(m.value ?? [], W), ce = K(i?.value ?? {}, "$each"), ve = K(o?.value ?? {}, "$each"), ge = v(() => f?.value?.$each);
      return Wr({ $id: d.value, path: a, cachePath: n, customMessages: r, rules: L ?? {}, stateValue: K(() => j), index: W, options: l, storage: s, externalErrors: ce, externalIssues: ve, schemaErrors: ge, initialState: B, originalState: h, shortcuts: O, fieldName: R, schemaMode: u, overrides: p, currentIndexes: G }) || null;
    }).filter((j) => !!j) : ($.value = [], G.clear()), k.value = Mt({ state: e, rulesDef: t, customMessages: r, path: a, cachePath: a, storage: s, options: l, externalErrors: K(i?.value ?? {}, "$self"), externalIssues: K(o?.value ?? {}, "$self"), schemaErrors: v(() => f?.value?.$self), $isArray: !0, initialState: m, originalState: h, shortcuts: O, fieldName: R, schemaMode: u, overrides: p });
  }
  function te() {
    if (Array.isArray(e.value) && (!F.isPrimitiveArray.value || u)) {
      let j = [...$.value], W = /* @__PURE__ */ new Set();
      $.value = e.value.map((b, L) => {
        let B = K(() => b);
        if (b.$id && $.value.find((ce) => ce.$id === b.$id)) {
          let ce = s.getArrayStatus(d.value, b.$id);
          if (ce) {
            let ve = G.get(b.$id);
            return ve && (ve.value = L), W.add(b.$id), ce.$value = B, ce;
          }
          return null;
        }
        {
          let { scope: ce, unwrapped: ve } = Lr(t.value.$each, B, L);
          ce && q.push(ce);
          let ge = K(i?.value ?? {}, "$each"), D = K(o?.value ?? {}, "$each"), re = v(() => f?.value?.$each ?? []), se = Wr({ $id: d.value, path: a, cachePath: a, customMessages: r, rules: ve ?? {}, stateValue: B, index: L, options: l, storage: s, externalErrors: ge, externalIssues: D, schemaErrors: re, initialState: K(m.value ?? [], L), originalState: h, shortcuts: O, fieldName: R, schemaMode: u, overrides: p, currentIndexes: G });
          return se ? (se.$id && W.add(se.$id), se) : null;
        }
      }).filter((b) => !!b), j.filter((b) => !e.value?.find((L) => b.$id === L.$id)).forEach((b, L) => {
        s.deleteArrayStatus(d.value, L.toString());
      });
      for (let b of G.keys()) W.has(b) || G.delete(b);
    } else $.value = [], G.clear();
  }
  function g() {
    T = le(e, () => {
      z?.(), e.value != null && !Object.hasOwn(e.value, "$id") && !d.value ? Y() : te(), A();
    }, { deep: !pr || 1, flush: "pre" }), A();
  }
  function A() {
    z = le(e, () => {
      S.$autoDirty.value && !S.$silent.value && k.value.$touch(!1, !0);
    }, { flush: "post" });
  }
  function J() {
    g(), w = ye(), S = w.run(() => {
      let j = v({ get: () => e.value, set(V) {
        T?.(), z?.(), e.value = V, g();
      } }), W = v(() => k.value.$dirty && (!$.value.length || $.value.every((V) => V.$dirty))), b = v(() => k.value.$anyDirty || $.value.some((V) => V.$anyDirty)), L = v(() => k.value.$invalid || $.value.some((V) => V.$invalid)), B = v(() => (u ? k.value.$correct : Ce(k.value.$rules) ? !0 : k.value.$correct) && (!$.value.length || $.value.every((V) => V.$correct || V.$anyDirty && !V.$invalid))), ce = v(() => k.value.$error || $.value.some((V) => V.$error)), ve = v(() => !(L.value || ge.value)), ge = v(() => k.value.$pending || $.value.some((V) => V.$pending)), D = v(() => !!$.value.length && $.value.every((V) => V.$edited)), re = v(() => k.value.$anyEdited || $.value.some((V) => V.$anyEdited)), se = v(() => ({ $self: k.value.$issues, $each: $.value.map((V) => V.$issues) })), be = v(() => ({ $self: k.value.$errors, $each: $.value.map((V) => V.$errors) })), je = v(() => ({ $self: k.value.$silentErrors, $each: $.value.map((V) => V.$silentErrors) })), Ee = v(() => N.value.$rewardEarly == null ? P(l.rewardEarly) != null && P(l.rewardEarly) === !0 : N.value.$rewardEarly), Ve = v(() => Ee.value ? !0 : N.value.$silent == null ? P(l.silent) != null && P(l.silent) === !0 : N.value.$silent), Ne = v(() => N.value.$autoDirty == null ? P(l.autoDirty) == null || P(l.autoDirty) === !0 : N.value.$autoDirty), Je = v(() => N.value.$immediateDirty == null ? P(l.immediateDirty) != null && gt(P(l.immediateDirty)) : gt(N.value.$immediateDirty)), ot = v(() => N.value.$clearExternalErrorsOnChange == null ? P(l.clearExternalErrorsOnChange) == null || P(l.clearExternalErrorsOnChange) === !0 : N.value.$clearExternalErrorsOnChange), ct = v(() => N.value.$clearExternalErrorsOnValidate == null ? P(l.clearExternalErrorsOnValidate) != null && P(l.clearExternalErrorsOnValidate) === !0 : N.value.$clearExternalErrorsOnValidate), et = v(() => {
        if (N.value.$isEdited != null) return N.value.$isEdited;
        if (p?.isEdited != null) return p.isEdited;
      }), Ke = v(() => R ?? l.id ?? "root"), Ye = v(() => ({ $deepCompare: N.value.$deepCompare ?? !1, $debounce: N.value.$debounce ?? P(l.debounce) ?? 0, $lazy: N.value.$lazy ?? !1, $rewardEarly: Ee.value, $autoDirty: Ne.value, $silent: Ve.value, $clearExternalErrorsOnChange: ot.value, $clearExternalErrorsOnValidate: ct.value, $immediateDirty: Je.value, $isEdited: et.value, $disabled: P(l.disabled) ?? !1 }));
      function x() {
        O?.collections && Object.entries(O?.collections).forEach(([V, Oe]) => {
          let ke = ye();
          ee[V] = ke.run(() => {
            let tt = I();
            return Qe(() => {
              tt.value = Oe(me({ $dirty: W, $error: ce, $path: a, $silentValue: j, $pending: ge, $invalid: L, $correct: B, $errors: be, $silentErrors: je, $initialValue: m, $originalValue: h, $ready: ve, $anyDirty: b, $name: Ke, $each: $, $self: k, $value: e, $output: e, $edited: D, $anyEdited: re, $issues: se }));
            }), tt;
          }), q.push(ke);
        });
      }
      let ee = {};
      return x(), { $dirty: W, $anyDirty: b, $invalid: L, $correct: B, $error: ce, $pending: ge, $errors: be, $silentErrors: je, $ready: ve, $name: Ke, $shortcuts: ee, $silentValue: j, $edited: D, $anyEdited: re, $rewardEarly: Ee, $silent: Ve, $autoDirty: Ne, $issues: se, $modifiers: Ye };
    }), F.isPrimitiveArray.value && t.value.$each && console.warn(`${a} is a Array of primitives. Tracking can be lost when reassigning the Array. We advise to use an Array of objects instead`);
  }
  function de() {
    T?.(), k.value && k.value.$unwatch(), $.value && $.value.forEach((j) => {
      "$dirty" in j && j.$unwatch();
    }), w.stop(), w = ye(), M.stop(), M = ye(!0), q.forEach((j) => j.stop()), q = [];
  }
  function Se(j = !0, W = !1) {
    k.value.$touch(j, W), $.value.forEach((b) => {
      b.$touch(j, W);
    });
  }
  function X(j, W) {
    if (de(), !W)
      if (j?.toOriginalState) e.value = ue(h), m.value = ue(h);
      else if (j?.toInitialState) e.value = ue(m.value);
      else if (j?.toState) {
        let b;
        b = typeof j?.toState == "function" ? j?.toState() : j?.toState, m.value = ue(b), e.value = ue(b);
      } else m.value = ue(e.value);
    j?.clearExternalErrors !== !1 && (he(), E()), j?.keepValidationState || (k.value.$reset(j, W), $.value.forEach((b) => {
      b.$reset(j, !0);
    })), W || Y();
  }
  function Ie() {
    k.value.$abort(), $.value.forEach((j) => {
      j.$abort();
    });
  }
  async function ne(j) {
    return j && (e.value = j), oe();
  }
  async function oe(j) {
    j && (e.value = j);
    let W = e.value;
    try {
      return Ie(), { valid: (await Promise.allSettled([k.value.$validateWithoutRaceconditions(j), ...$.value.map((b) => b.$validateWithoutRaceconditions())])).every((b) => b.status === "fulfilled" && b.value.valid === !0), data: W, errors: S.$errors.value, issues: S.$issues.value };
    } catch {
      return { valid: !1, data: W, errors: S.$errors.value, issues: S.$issues.value };
    }
  }
  function Pe(j) {
    j && (e.value = j);
    try {
      return [k.value.$validateSync(j), ...$.value.map((W) => W.$validateSync())].every((W) => !!W);
    } catch {
      return !1;
    }
  }
  function we(j) {
    i && (i.value = j), E();
  }
  function he() {
    k.value.$clearExternalErrors(), $.value.forEach((j) => {
      j.$clearExternalErrors();
    });
  }
  function c(j) {
    o && (o.value = j), he();
  }
  function E() {
    k.value.$clearExternalIssues(), $.value.forEach((j) => {
      j.$clearExternalIssues();
    });
  }
  function y(j = !0) {
    let W = $.value.map((b) => {
      if (da(b)) return b.$extractDirtyFields(j);
    });
    return j && W.every((b) => Ce(b)) && (W = []), W;
  }
  let { $shortcuts: _, ...H } = S;
  return me({ $self: k, ...H, ..._, $path: a, $each: $, $value: e, $output: e, $initialValue: m, $originalValue: h, $validate: ne, $validateSync: Pe, $validateWithoutRaceconditions: oe, $unwatch: de, $watch: J, $touch: Se, $reset: X, $abort: Ie, $extractDirtyFields: y, $clearExternalErrors: he, $clearExternalIssues: E, $setExternalErrors: we, $setExternalIssues: c, "~modifiers": S.$modifiers, ...mr(ne) });
}
function ir({ rulesDef: e, state: t, path: r = "", cachePath: a, rootRules: n, externalErrors: s, externalIssues: l, schemaErrors: i, rootInitialState: o, rootSchemaErrors: f, validationGroups: u, initialState: m, originalState: h, fieldName: O, nestedReactiveRules: R, ...p }) {
  let w = ye(), S, M = [], F = null, q = null, d = null, C = null, N = null, T = I(void 0);
  async function z(b = !0) {
    let L = Object.entries(e.value).filter(([D]) => D !== "$self"), B = Object.fromEntries(L.reduce((D, [re, se]) => {
      if (!se) return D;
      let be = K(t.value ?? {}, re), je = K(() => se), Ee = K(s?.value ?? {}, re), Ve = K(l?.value ?? {}, re), Ne = v(() => i?.value?.[re]), Je = K(m?.value ?? {}, re);
      return D.push([re, $t({ state: be, rulesDef: je, path: r ? `${r}.${re}` : re, cachePath: a ? `${a}.${re}` : re, externalErrors: Ee, externalIssues: Ve, schemaErrors: Ne, initialState: Je, originalState: h?.[re], fieldName: re, ...p })]), D;
    }, [])), ce = Object.fromEntries(Array.from(/* @__PURE__ */ new Set([...Object.keys(P(s) ?? {}), ...Object.keys(P(l) ?? {})])).filter((D) => !(D in e.value)).map((D) => {
      let re = K(t.value ?? {}, D), se = K(s?.value ?? {}, D), be = K(l?.value ?? {}, D), je = v(() => i?.value?.[D]), Ee = K(m?.value ?? {}, D), Ve = r ? `${r}.${D}` : D, Ne = a ? `${a}.${D}` : D;
      return [D, $t({ state: re, rulesDef: v(() => ({})), path: Ve, cachePath: Ne, externalErrors: se, externalIssues: be, schemaErrors: je, initialState: Ee, originalState: h?.[D], fieldName: D, ...p })];
    })), ve = Object.fromEntries(Object.entries(P(i) ?? {}).map(([D]) => {
      let re = r ? `${r}.${D}` : D, se = a ? `${a}.${D}` : D, be = K(t.value ?? {}, D), je = K(s?.value ?? {}, D), Ee = K(l?.value ?? {}, D), Ve = v(() => i?.value?.[D]), Ne = K(m?.value ?? {}, D);
      return [D, $t({ state: be, rulesDef: v(() => ({})), path: re, cachePath: se, externalErrors: je, externalIssues: Ee, schemaErrors: Ve, initialState: Ne, originalState: h?.[D], fieldName: D, ...p })];
    })), ge = Object.fromEntries(Object.entries(t.value ?? {}).filter(([D]) => !(D in e.value) && !(D in (ce ?? {})) && !(D in (ve ?? {}))).map(([D]) => {
      let re = K(t.value ?? {}, D), se = K(s?.value ?? {}, D), be = K(l?.value ?? {}, D), je = v(() => i?.value?.[D]), Ee = K(m?.value ?? {}, D);
      return [D, $t({ state: re, rulesDef: v(() => ({})), path: r ? `${r}.${D}` : D, cachePath: a ? `${a}.${D}` : D, externalErrors: se, externalIssues: be, schemaErrors: je, initialState: Ee, originalState: h?.[D], fieldName: D, ...p })];
    }));
    $.value = { ...B, ...ce, ...ve, ...ge }, b && g();
  }
  function k() {
    e.value.$self && (T.value = Mt({ state: t, rulesDef: v(() => e.value.$self ?? {}), path: r, cachePath: a, externalErrors: I(void 0), externalIssues: I(void 0), schemaErrors: I(void 0), initialState: m ?? I(void 0), originalState: h, fieldName: "$self", ...p }));
  }
  let $ = p.storage.getFieldsEntry(a);
  z(), k();
  function G() {
    s && (d = le(s, () => {
      A(), z();
    }, { deep: !0 }));
  }
  function Y() {
    l && (C = le(l, () => {
      A(), z();
    }, { deep: !0 }));
  }
  function te() {
    N = le(t, () => {
      A(), z(), S.$autoDirty.value && !S.$silent.value && oe(!1, !0), S.$clearExternalErrorsOnChange.value && (de(), X());
    }, { flush: "post" });
  }
  function g() {
    (n || R) && (F?.(), F = le(e, () => {
      A(), z();
    }, { deep: !0, flush: "pre" }), G(), Y()), f && (q?.(), q = le(() => f.value ? Object.keys(f.value).sort().join("\0") : "", () => {
      A(), z();
    }, { flush: "post" })), te(), S = w.run(() => {
      let b = v({ get: () => t.value, set(U) {
        A(), t.value = U, z(), S.$autoDirty.value && !S.$silent.value && oe(!1, !0), S.$clearExternalErrorsOnChange.value && (de(), X());
      } }), L = Jr(b), B = v({ get: () => t.value, set(U) {
        A(), t.value = U, z();
      } }), ce = v(() => {
        let U = $.value, Q = Object.keys(U);
        if (!Q.length) return !1;
        for (let pe of Q) if (!U[pe]?.$dirty) return !1;
        return !0;
      }), ve = v(() => {
        let U = $.value;
        for (let Q in U) if (U[Q]?.$anyDirty) return !0;
        return !1;
      }), ge = v(() => {
        if (T.value?.$invalid) return !0;
        let U = $.value, Q = Object.entries(U);
        if (!Q.length) return !1;
        for (let [pe, De] of Q) if (De?.$invalid) return !0;
        return !1;
      }), D = v(() => {
        let U = Object.entries($.value).reduce((pe, [De, ze]) => ((!lr(ze) || !ze.$inactive) && pe.push([De, ze]), pe), []), Q = e.value.$self && !Ce(e.value.$self);
        if (U.length || Q) {
          let pe = T.value?.$correct ?? !0, De = !1;
          return De = p.schemaMode ? U.every(([ze, Re]) => Re.$correct) : U.every(([ze, Re]) => lr(Re) ? "required" in Re.$rules && Re.$rules.required.$active ? Re.$correct : !Re.$invalid && !Re.$pending && !Re.$isDebouncing : Re?.$correct), pe && De;
        }
        return !1;
      }), re = v(() => {
        if (T.value?.$error) return !0;
        let U = $.value;
        if (!Object.keys(U).length) return !1;
        for (let Q in U) if (U[Q]?.$error) return !0;
        return !1;
      }), se = v(() => P(p.options.rewardEarly) != null && P(p.options.rewardEarly)), be = v(() => P(p.options.silent) == null ? !!se.value : P(p.options.silent) === !0), je = v(() => P(p.options.autoDirty) == null || P(p.options.autoDirty) === !0), Ee = v(() => P(p.options.immediateDirty) != null && gt(P(p.options.immediateDirty))), Ve = v(() => P(p.options.lazy) != null && P(p.options.lazy) === !0), Ne = v(() => P(p.options.clearExternalErrorsOnChange) == null || P(p.options.clearExternalErrorsOnChange) === !0), Je = v(() => P(p.options.clearExternalErrorsOnValidate) != null && P(p.options.clearExternalErrorsOnValidate) === !0), ot = v(() => !(ge.value || et.value)), ct = I(!1), et = v(() => {
        if (T.value?.$pending || ct.value) return !0;
        let U = $.value;
        for (let Q in U) if (U[Q]?.$pending) return !0;
        return !1;
      }), Ke = v(() => {
        let U = { ...T.value && { $self: T.value?.$issues ?? [] } };
        for (let Q in $.value) U[Q] = $.value[Q]?.$issues;
        return U;
      }), Ye = v(() => {
        let U = { ...T.value && { $self: T.value?.$errors ?? [] } };
        for (let Q in $.value) U[Q] = $.value[Q]?.$errors;
        return U;
      }), x = v(() => {
        let U = { ...T.value && { $self: T.value?.$silentErrors ?? [] } };
        for (let Q in $.value) U[Q] = $.value[Q]?.$silentErrors;
        return U;
      }), ee = v(() => {
        if (T.value?.$edited) return !0;
        if (!Object.keys($.value).length) return !1;
        for (let U in $.value) if (!$.value[U]?.$edited) return !1;
        return !0;
      }), V = v(() => {
        if (T.value?.$anyEdited) return !0;
        for (let U in $.value) if ($.value[U]?.$anyEdited) return !0;
        return !1;
      }), Oe = v(() => O ?? p.options.id ?? "root"), ke = v(() => ({ autoDirty: je.value, lazy: Ve.value, rewardEarly: se.value, silent: be.value, clearExternalErrorsOnChange: Ne.value, clearExternalErrorsOnValidate: Je.value, immediateDirty: Ee.value, id: P(p.options.id), disabled: P(p.options.disabled) }));
      function tt() {
        p.shortcuts?.nested && Object.entries(p.shortcuts.nested).forEach(([U, Q]) => {
          let pe = ye();
          ft[U] = pe.run(() => {
            let De = I();
            return Qe(() => {
              De.value = Q(me({ $dirty: ce, $path: r, $value: t, $output: t, $silentValue: B, $error: re, $originalValue: h, $pending: et, $invalid: ge, $correct: D, $ready: ot, $anyDirty: ve, $name: Oe, $silentErrors: x, $initialValue: m, $errors: Ye, $fields: $, $edited: ee, $anyEdited: V, $issues: Ke, $self: T, "~modifiers": We(p.options) }));
            }), De;
          }), M.push(pe);
        });
      }
      let Et = v({ get: () => u ? Object.fromEntries(Object.entries(u?.($.value) ?? {}).map(([U, Q]) => Q.length ? [U, { ...Object.fromEntries(["$invalid", "$error", "$pending", "$dirty", "$correct"].map((pe) => [pe, tl(Q, pe)])), ...Object.fromEntries(["$errors", "$silentErrors"].map((pe) => [pe, rl(Q, pe)])) }] : [])) : {}, set() {
      } }), ft = {};
      return tt(), { $dirty: ce, $anyDirty: ve, $invalid: ge, $correct: D, $error: re, $pending: et, $issues: Ke, $errors: Ye, $silentErrors: x, $clearExternalErrorsOnValidate: Je, $clearExternalErrorsOnChange: Ne, $ready: ot, $name: Oe, $shortcuts: ft, $groups: Et, $silentValue: B, $immediateDirty: Ee, $edited: ee, $anyEdited: V, $localPending: ct, $autoDirty: je, $silent: be, $value: b, $output: L, $modifiers: ke };
    });
  }
  function A() {
    if (F?.(), d?.(), C?.(), N?.(), q?.(), M.forEach((b) => b.stop()), M = [], S = {}, $.value) for (let b of Object.values($.value)) b?.$unwatch();
  }
  function J(b) {
    s && (s.value = n ? rr(b, t.value) : b), X();
  }
  function de() {
    s && !Ce(s.value) && (s.value = {});
  }
  function Se(b) {
    l && (l.value = b), de();
  }
  function X() {
    l && !Ce(l.value) && (l.value = {});
  }
  function Ie() {
    if (!S) return;
    let b = S.$immediateDirty.value;
    (b === "eager" || b === "non-empty" && ya(T.value, $.value, m.value)) && oe(!0, !1);
  }
  function ne(b, L) {
    if (d?.(), A(), !L)
      if (b?.toOriginalState) t.value = ue({ ...h }), m.value = ue({ ...h });
      else if (b?.toInitialState) t.value = ue({ ...m.value });
      else if (b?.toState) {
        let B;
        B = typeof b?.toState == "function" ? b?.toState() : b?.toState, m.value = ue(B), t.value = ue(B);
      } else m.value = ue(t.value);
    if (!b?.keepValidationState) {
      for (let B of Object.values($.value)) B?.$reset(b, !0);
      T.value?.$reset(b, !0);
    }
    b?.clearExternalErrors !== !1 && (de(), X()), G(), Y(), L || (z(), Ie());
  }
  function oe(b = !0, L = !1) {
    for (let B of Object.values($.value)) B?.$touch(b, L);
    T.value?.$touch(b, L);
  }
  function Pe(b) {
    return b.filter(([L, B]) => ie(B) && !Xe(B) ? !(B && typeof B == "object" && "_null" in B) && !Ce(B) : !Array.isArray(B) || B.length);
  }
  function we(b = !0) {
    let L = Object.entries($.value).map(([B, ce]) => [B, ce.$extractDirtyFields(b)]);
    return b && (L = Pe(L)), Object.fromEntries(L);
  }
  function he() {
    for (let b of Object.values($.value)) b.$abort();
    T.value?.$abort();
  }
  async function c(b) {
    return b && (t.value = b), await Ze(), E();
  }
  async function E(b) {
    let L = S;
    try {
      if (b && (t.value = b), p.schemaMode) return p.onValidate ? (oe(!1), L.$localPending.value = !0, p.onValidate()) : { valid: !1, data: t.value, errors: L.$errors.value, issues: L.$issues.value };
      {
        let B = t.value;
        he(), L.$clearExternalErrorsOnValidate.value && (de(), X());
        let ce = [...Object.values($.value).map((ve) => ve.$validateWithoutRaceconditions()), ...T.value ? [T.value?.$validateWithoutRaceconditions()] : []];
        return { valid: (await Promise.allSettled(ce)).every((ve) => ve.status === "fulfilled" && ve?.value?.valid === !0), data: B, errors: L.$errors.value, issues: L.$issues.value };
      }
    } catch {
      return { valid: !1, data: t.value, errors: L.$errors.value, issues: L.$issues.value };
    } finally {
      L.$localPending.value = !1;
    }
  }
  function y(b) {
    try {
      return b && (t.value = b), S.$clearExternalErrorsOnValidate.value && (de(), X()), [...Object.values($.value).map((L) => L.$validateSync()), ...T.value ? [T.value?.$validateSync()] : []].every((L) => !!L);
    } catch {
      return !1;
    }
  }
  Ie();
  let { $shortcuts: _, $localPending: H, ...j } = S, W = me({ ...j, ..._, $path: r, $initialValue: m, $originalValue: h, $self: T, $externalErrors: s, $externalIssues: l, $fields: $, $reset: ne, $touch: oe, $validate: c, $unwatch: A, $watch: g, $setExternalErrors: J, $setExternalIssues: Se, $clearExternalErrors: de, $clearExternalIssues: X, $extractDirtyFields: we, $abort: he, $validateSync: y, $validateWithoutRaceconditions: E, ...n ? { "~modifiers": S.$modifiers } : {}, ...mr(c) });
  return Object.defineProperty(W, /* @__PURE__ */ Symbol.for("regle:instance"), { value: !0 }), Qe(() => {
    for (let b of Object.keys(W).filter((L) => !L.startsWith("$") && !L.startsWith("~"))) delete W[b];
    for (let b of Object.values($.value)) b?.$name && Object.assign(W, { [b.$name]: b });
  }), W;
}
function $t({ rulesDef: e, ...t }) {
  if (il(e, t.state)) return pl({ rulesDef: e, ...t });
  if (fa(t.state, e)) {
    if (dr(t.state)) return ir({ rulesDef: e, ...t });
    {
      let r = ye().run(() => {
        let s = K(t.state.value ? t.state : I({}));
        return le(() => t.state.value, (l) => {
          s.value = l;
        }, { deep: !0 }), le(s, (l) => {
          t.state.value = l;
        }, { deep: !0 }), { fakeState: s };
      }), { state: a, ...n } = t;
      return ir({ rulesDef: e, ...n, state: r.fakeState });
    }
  }
  if (va(e)) return Mt({ rulesDef: xe(e.value) ? e.value : e, ...t });
}
function zr(e) {
  return Array.isArray(e) ? e.length > 0 : ie(e) && Object.keys(e).length > 0;
}
function Gr(e) {
  return Array.isArray(e) ? [] : {};
}
function yl(e, t) {
  let r = I(), a = I(), n, s, l, i, o = !1;
  function f() {
    let S = Gr(a.value ?? e.externalIssues?.value);
    a.value = S, e.externalIssues && (e.externalIssues.value = S);
  }
  function u() {
    let S = Gr(r.value ?? e.externalErrors?.value);
    r.value = S, e.externalErrors && (e.externalErrors.value = S);
  }
  function m(S, M = !1) {
    if (o) return;
    o = !0;
    let F = rr(S, P(t));
    r.value = F, M && e.externalErrors && (e.externalErrors.value = F), zr(F) && f(), o = !1;
  }
  function h(S, M = !1) {
    if (o) return;
    o = !0;
    let F = rr(S, P(t));
    a.value = F, M && e.externalIssues && (e.externalIssues.value = F), zr(F) && u(), o = !1;
  }
  function O() {
    n?.(), l?.(), n = le(() => e.externalErrors?.value, (S) => m(S), { deep: !0 }), l = le(() => e.externalIssues?.value, (S) => h(S), { deep: !0 });
  }
  function R() {
    s?.(), i?.(), s = le(() => r.value, (S) => m(S, !0), { deep: !0 }), i = le(() => a.value, (S) => h(S, !0), { deep: !0 });
  }
  function p() {
    w(), m(e.externalErrors?.value), h(e.externalIssues?.value), R();
  }
  function w() {
    s?.(), n?.(), i?.(), l?.(), s = void 0, n = void 0, i = void 0, l = void 0;
  }
  return { externalErrors: r, externalIssues: a, start: p, watchOptionRefs: O, stop: w };
}
function $a({ initialState: e, originalState: t, options: r, scopeRules: a, state: n, customRules: s, shortcuts: l, schemaErrors: i, schemaMode: o = !1, onValidate: f, overrides: u }) {
  let m = ol(), h = I(!1), O = /* @__PURE__ */ new Set(), R, p = I(), w = yl(r, n), S;
  function M() {
    S = le(() => P(r.disabled), async (k) => {
      k ? d() : (F(), w.start(), w.watchOptionRefs());
    });
  }
  function F() {
    fa(n, a) ? p.value = ir({ rootRules: a, rulesDef: a, state: n, customMessages: s?.(), storage: m, options: r, rootInitialState: e, externalErrors: w.externalErrors, externalIssues: w.externalIssues, validationGroups: r.validationGroups, initialState: e, originalState: t, shortcuts: l, fieldName: void 0, path: "", cachePath: "", schemaErrors: i, rootSchemaErrors: i, schemaMode: o, onValidate: f, overrides: u }) : va(a) && (p.value = Mt({ rulesDef: a, state: n, customMessages: s?.(), storage: m, options: r, rootInitialState: e, externalErrors: w.externalErrors, externalIssues: w.externalIssues, initialState: e, originalState: t, shortcuts: l, fieldName: void 0, path: "", cachePath: "", schemaMode: o, schemaErrors: i, onValidate: f, overrides: u }));
  }
  function q() {
    S = void 0;
  }
  function d() {
    p.value?.$unwatch(), w.stop();
  }
  function C() {
    h.value || (h.value = !0, R = ye(!0), R.run(() => {
      w.start(), F(), P(r.disabled) ? Ze().then(() => {
        p.value?.$unwatch();
      }) : w.watchOptionRefs(), M();
    }));
  }
  function N() {
    h.value && (h.value = !1, d(), S?.(), q(), R?.stop(), R = void 0, p.value = void 0, m.clearAll());
  }
  function T() {
    let k = Ft();
    !k || O.has(k) || (h.value || C(), O.add(k), Lt(() => {
      O.delete(k), O.size || N();
    }));
  }
  C(), T();
  function z() {
    typeof window < "u" && typeof __VUE_PROD_DEVTOOLS__ < "u" && __VUE_PROD_DEVTOOLS__ && !ca() && p.value && ll(p.value, { name: P(r.id) });
  }
  return z(), { regle: p, bindToCurrentScope: T };
}
function $l({ state: e, rulesFactory: t, options: r, globalOptions: a, customRules: n, shortcuts: s, overrides: l }) {
  let i = xe(t) ? t : typeof t == "function" ? void 0 : v(() => t), o = ur(oa, void 0) ?? {}, f = { ...o.modifiers, ...a }, u = () => ({ ...o.rules?.(), ...n?.() }), m = { ...o.shortcuts, ...s }, h = { ...o.overrides, ...l }, O = { ...f, ...r }, R, p = _e(i ?? {});
  typeof t == "function" && (R = Qe(() => {
    p.value = t(e), ja(p);
  }));
  let w = I(ie(e.value) ? { ...ue(e.value) } : ue(e.value)), S = ie(e.value) ? { ...ue(e.value) } : ue(e.value);
  $r(() => {
    R?.();
  });
  let { regle: M, bindToCurrentScope: F } = $a({ scopeRules: p, state: e, options: O, initialState: w, originalState: S, customRules: u, shortcuts: m, overrides: h });
  return { regle: M, bindToCurrentScope: F };
}
function ml(e) {
  let { rules: t, modifiers: r = {}, shortcuts: a, overrides: n } = {};
  function s(l, i, o) {
    let f = xe(l) ? l : I(l), u = v(() => P(o?.disabled) ?? !1), { regle: m, bindToCurrentScope: h } = $l({ state: f, rulesFactory: i, options: o, globalOptions: r, customRules: t, shortcuts: a, overrides: n });
    return { r$: Zn(m, u, () => {
      m.value || h();
    }) };
  }
  return s;
}
const hl = ml();
function zt(e, t) {
  let r = t ?? !1, a = v({ get: () => r ? Object.values(e).map((g) => g.$value) : Object.fromEntries(Object.entries(e).map(([g, A]) => [g, A.$value])), set: (g) => {
    r || typeof g == "object" && Object.entries(g).forEach(([A, J]) => e[A].$value = J);
  } }), n = v({ get: () => Object.fromEntries(Object.entries(e).map(([g, A]) => [g, A.$silentValue])), set: (g) => {
    typeof g == "object" && Object.entries(g).forEach(([A, J]) => e[A].$silentValue = J);
  } }), s = v(() => r ? Object.values(e).map((g) => g.$initialValue) : Object.fromEntries(Object.entries(e).map(([g, A]) => [g, A.$initialValue]))), l = v(() => r ? Object.values(e).map((g) => g.$originalValue) : Object.fromEntries(Object.entries(e).map(([g, A]) => [g, A.$originalValue]))), i = v(() => {
    let g = Object.entries(e);
    return !!g.length && g.every(([A, J]) => J?.$dirty);
  }), o = v(() => Object.entries(e).some(([g, A]) => A?.$anyDirty)), f = v(() => Object.entries(e).some(([g, A]) => A?.$invalid)), u = v(() => {
    let g = Object.entries(e);
    return !!g.length && g.every(([A, J]) => J?.$correct || J.$anyDirty && !J.$invalid);
  }), m = v(() => Object.entries(e).some(([g, A]) => A?.$error)), h = v(() => {
    let g = Object.entries(e);
    return !!g.length && g.every(([A, J]) => J?.$ready);
  }), O = v(() => Object.entries(e).some(([g, A]) => A?.$pending)), R = v(() => r ? Object.entries(e).map(([g, A]) => A.$issues) : Object.fromEntries(Object.entries(e).map(([g, A]) => [g, A.$issues]))), p = v(() => r ? Object.entries(e).map(([g, A]) => A.$silentIssues) : Object.fromEntries(Object.entries(e).map(([g, A]) => [g, A.$silentIssues]))), w = v(() => r ? Object.entries(e).map(([g, A]) => A.$errors) : Object.fromEntries(Object.entries(e).map(([g, A]) => [g, A.$errors]))), S = v(() => r ? Object.entries(e).map(([g, A]) => A.$silentErrors) : Object.fromEntries(Object.entries(e).map(([g, A]) => [g, A.$silentErrors]))), M = v(() => {
    let g = Object.entries(e);
    return !!g.length && g.every(([A, J]) => J?.$edited);
  }), F = v(() => Object.entries(e).some(([g, A]) => A?.$anyEdited)), q = v(() => r ? Object.values(e) : e);
  function d(g) {
    Object.values(e).forEach((A) => {
      A.$reset(g);
    });
  }
  function C() {
    Object.values(e).forEach((g) => {
      g.$touch();
    });
  }
  function N(g = !0) {
    return Object.values(e).map((A) => A.$extractDirtyFields(g));
  }
  function T(g) {
    Object.values(e).forEach((A) => {
      A.$setExternalErrors(g);
    });
  }
  function z(g) {
    Object.values(e).forEach((A) => {
      A.$setExternalIssues(g);
    });
  }
  function k() {
    Object.values(e).forEach((g) => {
      g.$clearExternalErrors();
    });
  }
  function $() {
    Object.values(e).forEach((g) => {
      g.$clearExternalIssues();
    });
  }
  function G(g) {
    try {
      return g && (a.value = g), Object.values(e).every((A) => A.$validateSync(g));
    } catch {
      return !1;
    }
  }
  async function Y(g) {
    try {
      g && (a.value = g);
      let A = a.value;
      return { valid: (await Promise.allSettled(Object.values(e).map((J) => J.$validate()))).every((J) => J.status === "fulfilled" && J.value.valid === !0), data: A, errors: w.value, issues: R.value };
    } catch {
      return { valid: !1, data: a.value, errors: w.value, issues: R.value };
    }
  }
  let te = me({ ...!r && { $silentValue: n }, $errors: w, $issues: R, $silentIssues: p, $silentErrors: S, $instances: q, $value: a, $initialValue: s, $originalValue: l, $output: a, $dirty: i, $anyDirty: o, $invalid: f, $correct: u, $error: m, $pending: O, $ready: h, $edited: M, $anyEdited: F, $reset: d, $touch: C, $validate: Y, $validateSync: G, $extractDirtyFields: N, $clearExternalErrors: k, $clearExternalIssues: $, $setExternalErrors: T, $setExternalIssues: z });
  return Qe(() => {
    if (!r) {
      for (let g of Object.keys(te).filter((A) => !A.startsWith("$") && !A.startsWith("~"))) delete te[g];
      for (let [g, A] of Object.entries(q.value)) Object.assign(te, { [g]: A });
    }
  }), te;
}
function gl(e, t) {
  function r(a) {
    let n = e(), s = v(() => P(a)), l = me({});
    f();
    let i = I(u(n.value)), o = me({ r$: i });
    function f() {
      s.value && (typeof s.value == "string" && !n.value[s.value] ? n.value[s.value] = {} : Array.isArray(s.value) && s.value.forEach((m) => {
        n.value[m] || (n.value[m] = {});
      }));
    }
    le(s, f), le(n, (m) => {
      i.value = u(m);
    }, { deep: !0 });
    function u(m) {
      return s.value ? typeof s.value == "string" ? zt(m[s.value] ?? {}, !t.asRecord) : (Object.keys(l).forEach((h) => {
        delete l[h];
      }), s.value.forEach((h) => {
        Object.entries(m[h]).forEach(([O, R]) => {
          Object.assign(l, { [O]: R });
        });
      }), zt(l, !t.asRecord)) : zt(m["~~global"] ?? {}, !t.asRecord);
    }
    return { r$: o.r$ };
  }
  return { useCollectScope: r };
}
function bl(e, t) {
  let r = t ?? hl;
  return { useScopedRegle: ((a, n, s) => {
    let { namespace: l, scopeKey: i, id: o, ...f } = s ?? {}, u = e();
    r.__config ??= {};
    let m = v(() => o ?? i), h = v(() => P(l)), O = I(`${Object.keys(u.value).length + 1}-${yr()}`), R = v(() => m.value ?? `instance-${O.value}`), { r$: p } = r(a, n, { ...f, id: m.value });
    S(), $r(w), le(h, (M, F) => {
      w(F), S();
    }), st() && sr(() => {
      let M = st();
      typeof window < "u" && M?.proxy?.$el?.parentElement && document.documentElement && !document.documentElement.contains(M?.proxy?.$el?.parentElement) && w();
    });
    function w(M) {
      let F = M ?? h.value;
      F ? u.value[F] && delete u.value[F][R.value] : u.value["~~global"][R.value] && delete u.value["~~global"][R.value];
    }
    function S() {
      h.value ? (u.value[h.value] || (u.value[h.value] = {}), u.value[h.value][R.value] = p) : (u.value["~~global"] || (u.value["~~global"] = {}), u.value["~~global"][R.value] = p);
    }
    return { r$: p, dispose: w, register: S };
  }) };
}
function ma(e) {
  e?.customStore && (e.customStore.value["~~global"] ? e.customStore.value = { "~~global": {} } : e.customStore.value["~~global"] = {});
  let t = /* @__PURE__ */ new WeakMap();
  function r() {
    if (e?.customStore) return e.customStore;
    let s = st()?.appContext.app;
    if (!s) return I({ "~~global": {} });
    let l = t.get(s);
    return l || (l = I({ "~~global": {} }), t.set(s, l)), l;
  }
  let { useScopedRegle: a } = bl(r, e?.customUseRegle), { useCollectScope: n } = gl(r, { asRecord: e?.asRecord });
  return { useScopedRegle: a, useCollectScope: n };
}
ma();
function El(e) {
  return e?.constructor?.name == "File";
}
function it(e) {
  return e && (e instanceof Date || e.constructor.name == "File" || e.constructor.name == "FileList") ? !1 : typeof e == "object" && !!e && !Array.isArray(e);
}
function Ol(e, t, r, a) {
  var n, s;
  if (Array.isArray(t) && (n = t.slice(0)), typeof t == "string" && (n = t.split(".")), typeof t == "symbol" && (n = [t]), !Array.isArray(n)) throw Error("props arg must be an array, a string or a symbol");
  if (s = n.pop(), !s) return !1;
  if (Hr(s)) throw Error("setting of prototype values not supported");
  for (var l; l = n.shift(); ) {
    if (Hr(l)) throw Error("setting of prototype values not supported");
    if (isNaN(parseInt(l)) ? (e[l] === void 0 && (e[l] = {}), e = e[l]) : (e.$each ?? (e.$each = []), Sl(e.$each[l]) && (e.$each[l] = {}), e = e.$each[l]), !e || typeof e != "object") return !1;
  }
  return a ? e[s] ? e[s].$self = (e[s].$self ??= []).concat(r) : e[s] = { $self: r } : isNaN(parseInt(s)) ? Array.isArray(e[s]) ? e[s] = e[s].concat(r) : e[s] = r : (e.$each ?? (e.$each = []), e.$each[s] = (e.$each[s] ??= []).concat(r)), !0;
}
function ha(e, t, r) {
  if (!e) return r;
  var a, n;
  if (Array.isArray(t) && (a = t.slice(0)), typeof t == "string" && (a = t.split(".")), typeof t == "symbol" && (a = [t]), !Array.isArray(a)) throw Error("props arg must be an array, a string or a symbol");
  for (; a.length; ) if (n = a.shift(), !e || !n || (e = e[n], e === void 0)) return r;
  return e;
}
function Hr(e) {
  let t = String(e);
  return t === "__proto__" || t === "constructor" || t === "prototype";
}
function Al(e, ...t) {
  for (var r = [].slice.call(arguments), a, n = r.length; a = r[n - 1], n--; ) if (!a || typeof a != "object" && typeof a != "function") throw Error("expected object, got " + a);
  for (var s = r[0], l = r.slice(1), i = l.length, n = 0; n < i; n++) {
    var o = l[n];
    for (var f in o) s[f] = o[f];
  }
  return s;
}
function Sl(e, t = !0, r = !0) {
  return e == null ? !0 : e instanceof Date ? isNaN(e.getTime()) : El(e) ? e.size <= 0 : Array.isArray(e) ? t ? e.length === 0 : !1 : it(e) ? e == null ? !0 : r ? Object.keys(e).length === 0 : !1 : !String(e).length;
}
function wl(e) {
  let t = [];
  return e.global && t.push("g"), e.ignoreCase && t.push("i"), e.multiline && t.push("m"), e.sticky && t.push("y"), e.unicode && t.push("u"), t.join("");
}
function Be(e, t = 0) {
  if (t > 20) return e;
  let r = e, a = {}.toString.call(e).slice(8, -1);
  if (a == "Set" && (r = new Set([...e].map((n) => Be(n, t + 1)))), a == "Map" && (r = new Map([...e].map((n) => [Be(n[0], t + 1), Be(n[1], t + 1)]))), a == "Date" && (r = new Date(e.getTime())), a == "RegExp" && (r = RegExp(e.source, wl(e))), a == "Array" || a == "Object") {
    r = Array.isArray(e) ? [] : {};
    for (let n in e) r[n] = Be(e[n], t + 1);
  }
  return r;
}
function jl(e, t, r) {
  if (!xe(e)) return r?.(), me(e);
  let a = I(!1);
  st() && sr(async () => {
    await Ze(), typeof window < "u" && window.requestAnimationFrame(() => {
      a.value = !0;
    });
  });
  let n = {}, s = new Proxy(n, { get(l, i, o) {
    if (r?.(), Reflect.getOwnPropertyDescriptor(n, i) || t.value && i !== "$value" && a.value) return Reflect.get(n, i, o);
    if (e.value !== void 0) return We(Reflect.get(e.value, i, o));
  }, set(l, i, o) {
    return r?.(), Reflect.getOwnPropertyDescriptor(n, i) ? Reflect.set(n, i, o) : (xe(e.value[i]) && !xe(o) ? e.value[i].value = o : e.value[i] = o, !0);
  }, deleteProperty(l, i) {
    return r?.(), Reflect.getOwnPropertyDescriptor(n, i) ? Reflect.deleteProperty(n, i) : Reflect.deleteProperty(e.value, i);
  }, has(l, i) {
    return r?.(), Reflect.has(n, i) ? !0 : e.value !== void 0 && Reflect.has(e.value, i);
  }, ownKeys() {
    r?.();
    let l = e.value === void 0 ? [] : Object.keys(e.value);
    return [.../* @__PURE__ */ new Set([...l, ...Reflect.ownKeys(n)])];
  }, getOwnPropertyDescriptor(l, i) {
    r?.();
    let o = Reflect.getOwnPropertyDescriptor(n, i);
    if (o) return o;
    if (!(e.value === void 0 || !Reflect.has(e.value, i))) return { enumerable: !0, configurable: !0, get: () => We(Reflect.get(e.value, i)), set: (f) => {
      xe(e.value[i]) && !xe(f) ? e.value[i].value = f : e.value[i] = f;
    } };
  }, defineProperty(l, i, o) {
    return r?.(), Reflect.defineProperty(n, i, o);
  } });
  return me(s);
}
function Vt(e) {
  return e.path?.map((t) => typeof t == "object" ? t.key : t.toString()).join(".") ?? "";
}
function Br(e) {
  let t = e.path?.at(-1);
  return typeof t == "object" ? t.key : t;
}
function kl(e) {
  let t = e.path?.at(-1), r = typeof t == "object" ? typeof t.key == "string" : typeof t == "string", a = e.path?.findLastIndex((n) => typeof n == "object" ? typeof n.key == "number" : typeof n == "number");
  if (!(!r && a === -1) && a != null) {
    let n = e.path?.slice(0, a + 1);
    return { ...e, path: n };
  }
}
function Rl(e, t) {
  let r = Vt(e), a = e.path?.[e.path.length - 1], n = typeof a == "object" ? a.key : a;
  return { isArray: typeof a == "object" && "value" in a && Array.isArray(a.value) || "type" in e && e.type === "array" || Array.isArray(ha(t.value, r)), $path: r, lastItemKey: n, lastItem: a };
}
function ga(e, t, r, a = !1) {
  return !a && r ? t.value.length ? t.value.reduce((n, s) => {
    if ("$currentArrayValue" in s && it(s.$currentArrayValue) && "$id" in s.$currentArrayValue) {
      let l = s.$currentArrayValue.$id, i = Br(s), o = e.find((f) => f?.$currentArrayValue?.$id === l && Br(f) === i);
      o && n.push({ ...s, path: o?.path ?? [] });
    } else e.some((l) => Vt(l) === Vt(s)) && n.push(s);
    return n;
  }, []) : [] : e;
}
function xl(e, t, r, a = !1) {
  return ga(e, t, r, a)?.map((n) => ({ $message: n.message, $property: n.path?.[n.path.length - 1]?.toString() ?? "-", $rule: "schema", ...n })) ?? [];
}
function Il({ result: e, previousIssues: t, processedState: r, rewardEarly: a, isValidate: n = !1 }) {
  let s = {}, l = e.issues?.map((o) => {
    let f = kl(o);
    if (f) {
      let u = ha(r.value, Vt(f));
      Object.defineProperty(o, "$currentArrayValue", { value: u, enumerable: !0, configurable: !0, writable: !0 });
    }
    return o;
  }), i = ga(l ?? [], t, a, n);
  if (l?.length) {
    let o = i.map((f) => {
      let { isArray: u, $path: m, lastItemKey: h } = Rl(f, r);
      return { ...f, $path: m, isArray: u, $property: h, $rule: "schema", $message: f.message };
    });
    o.forEach(({ isArray: f, $path: u, ...m }) => {
      Ol(s, u, [m], f);
    }), t.value = o;
  } else t.value = [];
  return s;
}
function Pl(e) {
  let t = xe(e) ? e : I(e);
  return { processedState: t, isSingleField: v(() => !it(t.value)), initialState: I(it(t.value) ? { ...Be(t.value) } : Be(t.value)), originalState: it(t.value) ? { ...Be(t.value) } : Be(t.value) };
}
function Dl({ processedState: e, getSchema: t, isSingleField: r, customErrors: a, previousIssues: n, resolvedOptions: s, syncOnUpdate: l, syncOnValidate: i }) {
  let o;
  function f() {
    u(), o = le([e, t], () => {
      s.silent || t()["~standard"].vendor !== "regle" && m();
    }, { deep: !0 });
  }
  function u() {
    o?.(), o = void 0;
  }
  async function m(h = !1) {
    let O = t()["~standard"].validate(e.value);
    return O instanceof Promise && (O = await O), a.value = r.value ? xl(O.issues ?? [], n, P(s.rewardEarly), h) : Il({ result: O, previousIssues: n, processedState: e, rewardEarly: P(s.rewardEarly), isValidate: h }), O.issues || (h && i || !h && l) && (u(), e.value = it(e.value) ? Al(e.value, O.value) : O.value, f()), O;
  }
  return { computeErrors: m, defineWatchState: f, stopWatching: u };
}
function _l(e) {
  let { options: t, shortcuts: r, overrides: a } = {};
  function n(s, l, i) {
    if (!We(l)?.["~standard"]) throw Error('Only "standard-schema" compatible libraries are supported');
    let { syncState: o = { onUpdate: !1, onValidate: !1 }, ...f } = i ?? {}, { onUpdate: u = !1, onValidate: m = !1 } = o, h = ur(oa, void 0) ?? {}, O = { ...h.modifiers, ...t, ...f }, R = { ...h.shortcuts, ...r }, p = { ...h.overrides, ...a }, { processedState: w, isSingleField: S, initialState: M, originalState: F } = Pl(s), q = I({}), d = I([]), C = /* @__PURE__ */ new Set(), N = !1, T, z, k;
    function $() {
      return Dl({ processedState: w, getSchema: () => We(l), isSingleField: S, customErrors: q, previousIssues: d, resolvedOptions: O, syncOnUpdate: u, syncOnValidate: m });
    }
    function G() {
      T?.stop(), T = ye(), T.run(() => {
        z = $(), z.defineWatchState(), z.computeErrors();
      });
    }
    function Y() {
      z?.stopWatching(), z = void 0, T?.stop(), T = void 0;
    }
    function te() {
      N || (N = !0, G(), k = le(() => P(O.disabled), (X) => {
        X ? Y() : G();
      }), P(O.disabled) && Ze().then(() => {
        Y();
      }));
    }
    function g() {
      N && (N = !1, k?.(), k = void 0, Y());
    }
    let A, J = async () => {
      try {
        let X = await (z ?? $()).computeErrors(!0);
        return A?.regle.value?.$touch(), { valid: !X.issues?.length, data: X.issues ? w.value : X.value, errors: A?.regle.value?.$errors, issues: q.value };
      } catch (X) {
        return Promise.reject(X);
      }
    };
    function de() {
      let X = Ft();
      !X || C.has(X) || (N || te(), C.add(X), Lt(() => {
        C.delete(X), C.size || g();
      }));
    }
    let Se = v(() => P(O.disabled) ?? !1);
    return te(), A = $a({ scopeRules: v(() => ({})), state: w, options: O, schemaErrors: q, initialState: M, originalState: F, shortcuts: R, schemaMode: !0, onValidate: J, overrides: p }), de(), { r$: jl(A.regle, Se, () => {
      A.regle.value || (de(), A.bindToCurrentScope());
    }) };
  }
  return n;
}
const ba = _l();
ma({ customUseRegle: ba });
const Tl = /* @__PURE__ */ ae(/* @__PURE__ */ Te(), /* @__PURE__ */ Ue(), /* @__PURE__ */ ht(/^[0-9]{4}[a-zA-Z]{2}$/)), Ul = Sa("order", () => {
  const e = I({
    customFields: [],
    paymentMethods: [],
    pickupPoints: [],
    products: [],
    timeslots: [],
    toggleableFields: {
      customerRemark: { enabled: !1, required: !1 },
      discount: { enabled: !1, required: !1 },
      donation: { enabled: !1, required: !1 },
      email: { enabled: !1, required: !1 },
      systemRemark: { enabled: !1, required: !1 },
      telephone: { enabled: !1, required: !1 }
    },
    configuration: {
      mode: Xt.Product
    }
  }), t = I(!1), r = I(!0), a = me({
    name: "",
    products: [],
    paymentMethod: 0,
    fulfillment: {
      timeslot: void 0,
      deliver: !0,
      data: {
        houseNumber: void 0,
        houseNumberSuffix: "",
        postalCode: ""
      }
    },
    toggleableFields: {
      customerRemark: "",
      discount: 0,
      donation: 0,
      email: "",
      systemRemark: "",
      telephone: ""
    },
    customFields: [],
    privacy: !1,
    tos: !1
  }), n = I(0), s = I(!1), l = I(!1), i = I(), o = I(Un), f = v({
    get() {
      return o.value;
    },
    set(c) {
      o.value = c;
    }
  }), u = me({
    hostUrl: "",
    enableDeliveries: !0
  }), m = I(!1), h = async function(c, E) {
    Object.assign(u, E), f.value = c;
    try {
      const y = await f.value(
        `${u.hostUrl}/api/v2/order/new`,
        {
          parseResponse: Pt,
          retryStatusCodes: [502]
        }
      );
      console.log("Fetched order options", y), console.log(
        "Delivery orders are " + (u.enableDeliveries ? "enabled" : "disabled")
      ), r.value = !0, y.timeslots = y.timeslots.map(
        (_) => ({
          ..._,
          date: new Date(_.date)
        })
      ), y.timeslots.sort(
        (_, H) => _.date.getTime() - H.date.getTime()
      );
      for (const _ of y.timeslots)
        _.slots.sort((H, j) => {
          const W = parseInt(H.start.slice(-8, -6)) * 100 + parseInt(H.start.slice(-5, -3)), b = parseInt(j.start.slice(-8, -6)) * 100 + parseInt(j.start.slice(-5, -3));
          return W < b ? -1 : 1;
        });
      if (y.paymentMethods.sort(
        (_, H) => _.id - H.id
      ), !u.enableDeliveries && y.pickupPoints.length == 0)
        throw Error(
          "No pickup points available while deliveries are disabled. Checkout is closed"
        );
      e.value = y, m.value = !0, O();
    } catch (y) {
      console.error(
        "Failed to fetch order options or setup a first order:",
        y
      ), r.value = !1;
    } finally {
      t.value = !0;
    }
  }, O = function() {
    if (!t.value && !m.value)
      throw new Error(
        "Cannot reset the order before the options are ready"
      );
    const c = {};
    c.products = [];
    for (const y of e.value.products)
      c.products.push({
        id: y.id,
        amount: 0
      });
    c.paymentMethod = e.value.paymentMethods[0].id, u.enableDeliveries ? c.fulfillment = {
      timeslot: void 0,
      deliver: !0,
      data: {
        postalCode: "",
        houseNumber: void 0,
        houseNumberSuffix: ""
      }
    } : c.fulfillment = {
      timeslot: void 0,
      deliver: !1,
      data: {
        pickupPoint: e.value.pickupPoints.length == 1 ? e.value.pickupPoints[0].id : void 0
      }
    }, c.name = "", c.toggleableFields = {}, e.value.toggleableFields.customerRemark?.enabled && (c.toggleableFields.customerRemark = ""), e.value.toggleableFields.discount?.enabled && (c.toggleableFields.discount = 0), e.value.toggleableFields.donation?.enabled && (c.toggleableFields.donation = 0), e.value.toggleableFields.email?.enabled && (c.toggleableFields.email = ""), e.value.toggleableFields.systemRemark?.enabled && (c.toggleableFields.systemRemark = ""), e.value.toggleableFields.telephone?.enabled && (c.toggleableFields.telephone = ""), c.customFields = [];
    const E = {
      string: "",
      integer: 0,
      boolean: !1
    };
    for (const y of e.value.customFields) {
      if (y.type == "integer" && y.required) {
        c.customFields.push({
          id: y.id,
          value: void 0
        });
        continue;
      }
      c.customFields.push({
        id: y.id,
        value: y.default ?? E[y.type]
      });
    }
    console.dir(c.customFields), Object.assign(a, c);
  }, R = () => {
    m.value = !1, t.value = !1, r.value = !1, p.value = "", M.value = [], F.value = [], q.value = [], e.value = {
      customFields: [],
      paymentMethods: [],
      pickupPoints: [],
      products: [],
      timeslots: [],
      toggleableFields: {
        customerRemark: { enabled: !1, required: !1 },
        discount: { enabled: !1, required: !1 },
        donation: { enabled: !1, required: !1 },
        email: { enabled: !1, required: !1 },
        systemRemark: { enabled: !1, required: !1 },
        telephone: { enabled: !1, required: !1 }
      },
      configuration: {
        mode: Xt.Product
      }
    }, he.$reset();
  }, p = I(""), w = v(() => e.value.pickupPoints.length > 0), S = v(() => u.enableDeliveries), M = I([]), F = I([]), q = I([]);
  qt(
    [
      () => a.fulfillment.data,
      () => a.fulfillment.deliver
    ],
    async ([c, E]) => {
      if (!t.value || !E) return;
      const y = c;
      l.value = !1, i.value = void 0, p.value = "";
      const _ = y.postalCode.replaceAll(" ", "").match(/[0-9]{4}([a-zA-Z]{2})/g), H = y.houseNumber, j = y.houseNumberSuffix.replaceAll(
        /[^a-zA-Z]*/g,
        ""
      );
      !_ || !H || (s.value = !0, await d(
        _[0],
        H,
        j
      ));
    },
    { deep: !0, debounce: 500 }
  );
  const d = async (c, E, y) => {
    try {
      const _ = await f.value(
        `${u.hostUrl}/api/v2/address/lookup`,
        {
          query: {
            postalCode: c,
            houseNumber: E + y
          },
          parseResponse: Pt
        }
      );
      if (p.value = `${_.address.street} ${_.address.houseNumber}${_.address.houseNumberSuffix} te ${_.address.city}`, _.status == "AREA_NOT_SUPPORTED") {
        i.value = Ge.AREA_NOT_SUPPORTED;
        return;
      }
      if (_.status !== "SUPPORTED") {
        i.value = Ge.NO_AVAILABILITY;
        return;
      }
      M.value = _.pricelist, F.value = _.availability, q.value = _.inventory, n.value = _.locationFee, l.value = !0;
    } catch (_) {
      if (_.data?.errorCode === -908) {
        i.value = Ge.NOT_FOUND;
        return;
      }
      i.value = Ge.UNAVAILABLE;
    } finally {
      s.value = !1;
    }
  };
  qt(
    [
      () => a.fulfillment.data,
      () => a.fulfillment.deliver
    ],
    async ([c, E]) => {
      if (!t.value || E) return;
      const y = c.pickupPoint;
      if (l.value = !1, i.value = void 0, y === void 0)
        return;
      if (s.value = !0, e.value.pickupPoints.find(
        (H) => H.id == y
      ) === void 0) {
        console.warn(
          "[!] a pickuppoint was selected that was not specified in the options request"
        ), i.value = Ge.NOT_FOUND;
        return;
      }
      await C(y);
    },
    { deep: !0, debounce: 500 }
  );
  const C = async (c) => {
    try {
      const E = await f.value(
        `${u.hostUrl}/api/v2/pickuppoint/${c}`,
        {
          parseResponse: Pt
        }
      );
      if (E.status !== "SUPPORTED") {
        i.value = Ge.NO_AVAILABILITY;
        return;
      }
      M.value = E.pricelist, F.value = E.availability, q.value = E.inventory, n.value = E.locationFee, l.value = !0;
    } catch (E) {
      if (E.data?.errorCode === -31) {
        i.value = Ge.NOT_FOUND;
        return;
      }
      i.value = Ge.UNAVAILABLE;
      return;
    } finally {
      s.value = !1;
    }
  }, N = v(() => {
    if (!l.value) return {};
    const c = {};
    return e.value.products.forEach((E) => {
      const y = M.value.find(
        (H) => H.productId == E.id
      ), _ = F.value.find(
        (H) => H.productId == E.id
      );
      y == null || y.active === !1 || _ == null || _.timeslotIds.length === 0 ? c[E.id] = {
        active: !1,
        price: void 0
      } : c[E.id] = {
        active: !0,
        price: y.price
      };
    }), c;
  }), T = v(() => a.products.filter((c) => c.amount > 0).map(({ id: c }) => c)), z = v(() => t.value ? F.value.filter((c) => T.value.includes(c.productId)).map(({ timeslotIds: c }) => new Set(c)) : []), k = v(() => {
    const c = z;
    if (c.value.length === 0)
      return [];
    const E = c.value.reduce(
      (H, j) => H.intersection(j)
    ), y = q.value.filter(
      (H) => (
        // Filter all products that don't have enough stock available to fulfill the complete order
        H.products.every((j) => {
          const W = a.products.find(
            (b) => b.id === j.productId
          );
          return !W || W.amount === 0 || j.availableStock >= W.amount;
        })
      )
    ).map((H) => H.inventoryId);
    return We(e.value.timeslots).map((H) => ({
      ...H,
      slots: H.slots.filter(
        (j) => E.has(j.id) && y.includes(j.inventoryId)
      )
    })).filter((H) => H.slots.length > 0);
  });
  qt(
    () => k.value,
    (c) => {
      if (!t.value || a.fulfillment.timeslot === void 0) return;
      new Set(
        c.flatMap((y) => y.slots.map((_) => _.id))
      ).has(a.fulfillment.timeslot) || (a.fulfillment.timeslot = void 0);
    }
  );
  const $ = v(() => {
    if (a.fulfillment.timeslot !== void 0) {
      for (const c of e.value.timeslots)
        for (const E of c.slots)
          if (E.id === a.fulfillment.timeslot)
            return E;
    }
  }), G = v(() => {
    if (!l.value) return [];
    if (a.fulfillment.timeslot !== void 0) {
      const c = $.value?.inventoryId;
      return q.value.find(
        (E) => E.inventoryId === c
      )?.products ?? [];
    } else {
      const c = [];
      for (const E of q.value)
        for (const y of E.products)
          c[y.productId] = Math.max(
            c[y.productId] ?? 0,
            y.availableStock
          );
      return Object.entries(c).map(
        ([E, y]) => ({
          productId: Number(E),
          availableStock: y
        })
      );
    }
  }), Y = v(() => {
    let c = 0;
    return a.products.forEach((E) => {
      const y = N.value?.[E.id];
      y?.active && (c += y.price * E.amount);
    }), e.value.toggleableFields.donation?.enabled && a.toggleableFields.donation !== void 0 && (c += a.toggleableFields.donation), e.value.toggleableFields.discount?.enabled && a.toggleableFields.discount !== void 0 && (c -= a.toggleableFields.discount), c += n.value, c;
  }), te = (c) => {
    let E = !1;
    for (const y of a.products)
      y.amount = y.id === c ? 1 : 0, y.id === c && (E = !0);
    if (!E)
      throw new Error("Service not found in current order");
  }, g = (c, E) => {
    const y = a.products.find(
      (_) => _.id === c
    );
    if (!y)
      throw new Error("Product not found in current order");
    y.amount = E;
  }, A = (c, E) => {
    if (!e.value.customFields.find(
      (H) => H.id === c
    ))
      throw new Error("Custom field configuration not found");
    const _ = a.customFields.find(
      (H) => H.id === c
    );
    if (!_)
      throw new Error("Custom field not found in current order");
    _.value = E;
  }, J = async () => {
    if (t.value && a.fulfillment.deliver) {
      const c = a.fulfillment.data, E = c.postalCode.replaceAll(" ", "").match(/[0-9]{4}([a-zA-Z]{2})/g), y = c.houseNumber, _ = c.houseNumberSuffix.replaceAll(
        /[^a-zA-Z]*/g,
        ""
      );
      if (!E || !y) return;
      s.value = !0, await d(
        E[0],
        y,
        _
      );
    }
  }, de = (c, E) => {
    let y;
    if (c.type === "string") {
      if (y = /* @__PURE__ */ ae(/* @__PURE__ */ Te(), /* @__PURE__ */ Ue()), c.required && (y = /* @__PURE__ */ ae(
        y,
        /* @__PURE__ */ xt(1, E.required)
      )), c.configuration?.length?.min !== void 0) {
        const _ = c.configuration.length.min;
        y = /* @__PURE__ */ ae(
          y,
          /* @__PURE__ */ xt(_, E.minLength(_))
        );
      }
      if (c.configuration?.length?.max !== void 0) {
        const _ = c.configuration.length.max;
        y = /* @__PURE__ */ ae(
          y,
          /* @__PURE__ */ Xr(_, E.maxLength(_))
        );
      }
      c.configuration?.regex !== void 0 && (y = /* @__PURE__ */ ae(
        y,
        /* @__PURE__ */ ht(
          new RegExp(c.configuration.regex),
          E.pattern
        )
      ));
    } else if (c.type === "integer") {
      if (y = /* @__PURE__ */ ae(
        /* @__PURE__ */ Fe(
          /* @__PURE__ */ fr([
            /* @__PURE__ */ Te(),
            /* @__PURE__ */ ae(/* @__PURE__ */ Me(), /* @__PURE__ */ lt(String))
          ]),
          "Dit veld moet een getal zijn."
        ),
        /* @__PURE__ */ ht(/^[0-9]+$/, "Dit veld mag alleen getallen bevatten."),
        /* @__PURE__ */ lt(Number)
      ), c.required && (y = /* @__PURE__ */ Dt(y, E.required)), c.configuration?.min !== void 0) {
        const _ = c.configuration.min;
        y = /* @__PURE__ */ ae(
          y,
          /* @__PURE__ */ It(_, E.minValue(_))
        );
      }
      if (c.configuration?.max !== void 0) {
        const _ = c.configuration.max;
        y = /* @__PURE__ */ ae(
          y,
          /* @__PURE__ */ Jt(_, E.maxValue(_))
        );
      }
    } else if (c.type === "boolean")
      y = /* @__PURE__ */ ae(/* @__PURE__ */ ra()), c.required && (y = /* @__PURE__ */ ae(
        y,
        /* @__PURE__ */ He(!0, E.required)
      ));
    else
      throw new Error("Unknown custom field type");
    return y;
  }, Se = v(() => {
    const c = {
      required: "Dit veld is verplicht.",
      minLength: (y) => "Dit veld moet minimaal " + y + " tekens bevatten.",
      maxLength: (y) => "Dit veld mag maximaal " + y + " tekens bevatten.",
      minValue: (y) => "Dit veld moet minimaal " + y + " zijn.",
      maxValue: (y) => "Dit veld mag maximaal " + y + " zijn.",
      pattern: "De waarde is niet geldig.",
      maxWords: (y) => "Dit veld mag maximaal " + y + " woorden bevatten.",
      notEnoughStockAvailable: "Er is niet genoeg voorraad beschikbaar voor dit product.",
      minAmountOfProducts: "Er moet minimaal 1 product gekozen worden.",
      invalidPostalCode: "De ingevulde postcode is ongeldig.",
      invalidHouseNumber: "Het ingevulde huisnummer is ongeldig.",
      invalidTelephone: "Het ingevulde telefoonnummer is ongeldig.",
      invalidEmail: "Het ingevulde e-mailadres is ongeldig."
    }, E = /* @__PURE__ */ Yt(
      /* @__PURE__ */ Zt(
        "id",
        e.value.customFields.map(
          (y) => /* @__PURE__ */ qe({
            id: /* @__PURE__ */ He(y.id),
            value: de(y, c)
          })
        )
      )
    );
    return /* @__PURE__ */ qe({
      name: /* @__PURE__ */ ae(/* @__PURE__ */ Te(), /* @__PURE__ */ Ue(), /* @__PURE__ */ xt(3, c.minLength(3))),
      paymentMethod: /* @__PURE__ */ Me(),
      fulfillment: /* @__PURE__ */ aa([
        /* @__PURE__ */ qe({
          timeslot: /* @__PURE__ */ Fe(/* @__PURE__ */ Dt(/* @__PURE__ */ Me()), c.required)
        }),
        /* @__PURE__ */ Zt("deliver", [
          /* @__PURE__ */ qe({
            deliver: /* @__PURE__ */ He(!0),
            data: /* @__PURE__ */ qe({
              postalCode: /* @__PURE__ */ Fe(
                Tl,
                c.invalidPostalCode
              ),
              houseNumber: /* @__PURE__ */ Fe(
                /* @__PURE__ */ ae(/* @__PURE__ */ Me(), /* @__PURE__ */ It(0)),
                c.invalidHouseNumber
              ),
              houseNumberSuffix: /* @__PURE__ */ Fe(
                /* @__PURE__ */ ae(/* @__PURE__ */ Te(), /* @__PURE__ */ Ue()),
                c.invalidHouseNumber
              )
            })
          }),
          /* @__PURE__ */ qe({
            deliver: /* @__PURE__ */ He(!1),
            data: /* @__PURE__ */ Fe(
              /* @__PURE__ */ qe({
                pickupPoint: /* @__PURE__ */ Me()
              }),
              c.required
            )
          })
        ])
      ]),
      products: /* @__PURE__ */ ae(
        /* @__PURE__ */ Yt(
          /* @__PURE__ */ qe({
            id: /* @__PURE__ */ Me(),
            amount: /* @__PURE__ */ ae(/* @__PURE__ */ Me(), /* @__PURE__ */ It(0))
          })
        ),
        /* @__PURE__ */ lt(
          (y) => y.filter((_) => _.amount > 0)
        ),
        /* @__PURE__ */ ea(0, c.minAmountOfProducts),
        /* @__PURE__ */ Qr((y) => y.amount <= (G.value.find(
          (_) => _.productId == y.id
        )?.availableStock ?? 0), c.notEnoughStockAvailable)
      ),
      customFields: E,
      toggleableFields: /* @__PURE__ */ qa(
        /* @__PURE__ */ qe({
          email: /* @__PURE__ */ ae(
            kt,
            nt(
              !e.value.toggleableFields.email?.required,
              /* @__PURE__ */ ae(
                /* @__PURE__ */ Te(),
                /* @__PURE__ */ Ue(),
                /* @__PURE__ */ Zr(c.invalidEmail)
              )
            )
          ),
          telephone: /* @__PURE__ */ ae(
            kt,
            nt(
              !e.value.toggleableFields.telephone?.required,
              /* @__PURE__ */ Fe(Wn, c.invalidTelephone)
            )
          ),
          customerRemark: /* @__PURE__ */ ae(
            kt,
            nt(
              !e.value.toggleableFields.customerRemark?.required,
              /* @__PURE__ */ Fe(
                /* @__PURE__ */ ae(
                  /* @__PURE__ */ Te(),
                  /* @__PURE__ */ Ue(),
                  /* @__PURE__ */ Kt("nl", 500)
                ),
                c.maxWords(500)
              )
            )
          ),
          systemRemark: /* @__PURE__ */ ae(
            kt,
            nt(
              !e.value.toggleableFields.systemRemark?.required,
              /* @__PURE__ */ Fe(
                /* @__PURE__ */ ae(
                  /* @__PURE__ */ Te(),
                  /* @__PURE__ */ Ue(),
                  /* @__PURE__ */ Kt("nl", 500)
                ),
                c.maxWords(500)
              )
            )
          ),
          donation: nt(
            !e.value.toggleableFields.donation?.required,
            /* @__PURE__ */ Fe(
              /* @__PURE__ */ ae(/* @__PURE__ */ Me(), /* @__PURE__ */ Jt(1e4)),
              "Het getal mag niet hoger zijn dan 100."
            )
            // Maximum of 100 euros, 100 00 cents
          ),
          discount: nt(
            !e.value.toggleableFields.discount?.required,
            /* @__PURE__ */ Fe(
              /* @__PURE__ */ ae(
                /* @__PURE__ */ Me(),
                /* @__PURE__ */ Yr(
                  (y) => y == 0 || Y.value >= 0
                )
              ),
              "De korting mag niet hoger zijn dan het totaalbedrag"
            )
          )
        })
      ),
      tos: /* @__PURE__ */ He(!0, c.required),
      privacy: /* @__PURE__ */ He(!0, c.required)
    });
  }), X = I(!1), Ie = I({}), ne = I(We(a)), oe = v(() => {
    if (!t.value) return;
    const c = {
      name: ne.value.name,
      email: ne.value.toggleableFields.email,
      telephone: ne.value.toggleableFields.telephone
    }, E = {
      paymentMethod: ne.value.paymentMethod,
      donation: ne.value.toggleableFields.donation,
      discount: ne.value.toggleableFields.discount,
      items: ne.value.products.map((_) => ({
        product: _.id,
        amount: _.amount
      }))
    };
    let y;
    return ne.value.fulfillment.deliver ? y = {
      timeslot: ne.value.fulfillment.timeslot,
      type: "delivery",
      postalCode: ne.value.fulfillment.data.postalCode,
      houseNumber: ne.value.fulfillment.data.houseNumber + ne.value.fulfillment.data.houseNumberSuffix
    } : y = {
      timeslot: ne.value.fulfillment.timeslot,
      type: "pickup",
      pickupPoint: ne.value.fulfillment.data.pickupPoint
    }, {
      customer: c,
      sale: E,
      fulfillment: y,
      customFields: ne.value.customFields,
      customerRemark: ne.value.toggleableFields.customerRemark
    };
  });
  le(() => [a, Se.value], () => {
    const c = /* @__PURE__ */ Ua(Se.value, a);
    Ie.value = c.success ? {} : (/* @__PURE__ */ Ma(c.issues)).nested, ne.value = c.output, X.value = c.success;
  }, {
    deep: !0
  });
  const we = v(() => {
    if (t.value && !(k.value.length > 0) && !i.value) {
      if (z.value.length > 0 && k.value.length <= 0)
        return Tr.NO_INVENTORY;
      if (!F.value.some(
        (c) => c.timeslotIds.length > 0
      ))
        return Tr.AT_CAPACITY;
    }
  }), { r$: he } = ba(
    a,
    Se,
    {
      autoDirty: !1
    }
  );
  return {
    // Basic state and actions
    options: e,
    ready: t,
    checkoutOpen: r,
    initialize: h,
    resetOrder: O,
    // Current order state
    currentOrder: a,
    // Finalized order ready to be sent to the API
    orderPayload: oe,
    // Meta properties of the store. Provides information that can be used in frontends.
    meta: Jr({
      fulfillmentComplete: l,
      fulfillmentFee: n,
      loadingFulfillment: s,
      fulfillmentError: i,
      timeslotAvailabilityError: we,
      selectedTimeslot: $,
      streetName: p,
      pricelist: N,
      totalPrice: Y,
      availableTimeslots: k,
      effectiveInventory: G,
      inventoryEntries: q,
      pickupEnabled: w,
      deliveriesEnabled: S
    }),
    // Contains helper functions to ease changing certain properties
    helpers: {
      setService: te,
      setProduct: g,
      setCustomField: A,
      refreshFulfillment: J
    },
    validation: {
      isValid: X,
      schema: Se.value,
      errors: Ie,
      r$: Dr(he)
    },
    // These methods are _not_ meant to be manipulated or even read outside of this store,
    // backwards or forward compatibility of the inner workings of these variables is not assured
    _ready: m,
    _config: u,
    $reset: R,
    storeFetch: Dr(f)
  };
});
function Le(e) {
  if (typeof e != "object") return e;
  var t, r, a = Object.prototype.toString.call(e);
  if (a === "[object Object]") {
    if (e.constructor !== Object && typeof e.constructor == "function") {
      r = new e.constructor();
      for (t in e)
        e.hasOwnProperty(t) && r[t] !== e[t] && (r[t] = Le(e[t]));
    } else {
      r = {};
      for (t in e)
        t === "__proto__" ? Object.defineProperty(r, t, {
          value: Le(e[t]),
          configurable: !0,
          enumerable: !0,
          writable: !0
        }) : r[t] = Le(e[t]);
    }
    return r;
  }
  if (a === "[object Array]") {
    for (t = e.length, r = Array(t); t--; )
      r[t] = Le(e[t]);
    return r;
  }
  return a === "[object Set]" ? (r = /* @__PURE__ */ new Set(), e.forEach(function(n) {
    r.add(Le(n));
  }), r) : a === "[object Map]" ? (r = /* @__PURE__ */ new Map(), e.forEach(function(n, s) {
    r.set(Le(s), Le(n));
  }), r) : a === "[object Date]" ? /* @__PURE__ */ new Date(+e) : a === "[object RegExp]" ? (r = new RegExp(e.source, e.flags), r.lastIndex = e.lastIndex, r) : a === "[object DataView]" ? new e.constructor(Le(e.buffer)) : a === "[object ArrayBuffer]" ? e.slice(0) : a.slice(-6) === "Array]" ? new e.constructor(e) : e;
}
const Nl = {
  paymentMethods: [
    {
      id: 0,
      label: "Ideal"
    },
    {
      id: 1,
      label: "Pinnen"
    },
    {
      id: 2,
      label: "Contanten"
    },
    {
      id: 3,
      label: "Eigen betaalmethode"
    }
  ],
  pickupPoints: [
    {
      id: 0,
      label: "Goedkoop afhaalpunt",
      description: "Afhaalpunt bij de vereniging"
    },
    {
      id: 1,
      label: "Duur afhaalpunt",
      description: "Afhaalpunt met flinke markup"
    }
  ],
  products: [
    {
      id: 0,
      label: "Sinterklaas bezoek",
      amount: 1,
      description: "Een bezoekje van de goedheiligman",
      pluralUnitLabel: "bezoeken",
      unitLabel: "bezoek"
    },
    {
      id: 1,
      label: "Pieten bezoek",
      amount: 1,
      description: "Een bezoekje van de pieten en de goedheiligman",
      pluralUnitLabel: "bezoeken",
      unitLabel: "bezoek"
    },
    {
      id: 2,
      label: "Pepernoten pakket",
      amount: 10,
      description: "Een pakket met pepernoten bezorgt door de PostPiet",
      pluralUnitLabel: "pakketten",
      unitLabel: "pakket"
    }
  ],
  timeslots: Cl(),
  toggleableFields: {
    customerRemark: { enabled: !0, required: !1 },
    donation: { enabled: !0, required: !1 },
    email: { enabled: !0, required: !1 },
    systemRemark: { enabled: !0, required: !1 },
    telephone: { enabled: !0, required: !1 },
    hcaptcha: { enabled: !0, required: !0 }
  },
  customFields: [],
  configuration: {
    mode: Xt.Product,
    hcaptchaSiteKey: "20000000-ffff-ffff-ffff-000000000002"
  }
};
function Cl() {
  const e = /* @__PURE__ */ new Date("2025-01-01"), t = [];
  for (let r = 0; r < 7; r++) {
    const a = new Date(e);
    a.setDate(a.getDate() + r);
    const n = [];
    let s = 0;
    for (let l = 9; l < 21; l += 3) {
      const i = `${l}:00:00`, o = `${l + 3}:00:00`;
      n.push({
        id: s + r * 4,
        inventoryId: r,
        start: i,
        end: o
      }), s++;
    }
    t.push({
      date: a,
      slots: n
    });
  }
  return t;
}
const Wl = (e = {}) => ({
  ...Le(Nl),
  ...e
}), Gt = [...Array(8).keys()], Vl = {
  address: {
    postalCode: "0000XX",
    houseNumber: 69,
    houseNumberSuffix: "",
    street: "Bollenstraat",
    city: "Aarde stad"
  },
  status: "SUPPORTED",
  locationFee: 0,
  pricelist: [
    {
      productId: 0,
      price: 100,
      active: !0
    },
    {
      productId: 1,
      price: 500,
      active: !0
    },
    {
      productId: 2,
      price: 200,
      active: !0
    }
  ],
  availability: [
    {
      productId: 0,
      timeslotIds: Gt
    },
    {
      productId: 1,
      timeslotIds: [
        Gt,
        [...Array(12).keys()].map((e) => e + 8)
      ].flat()
      // Also make the 3 following days available
    },
    {
      productId: 2,
      timeslotIds: [
        Gt,
        [...Array(12).keys()].map((e) => e + 12)
      ].flat()
    }
  ],
  inventory: [0, 1, 2, 3, 4, 5, 6].map((e) => ({
    inventoryId: e,
    products: [
      { productId: 0, availableStock: 10 },
      { productId: 1, availableStock: 10 },
      { productId: 2, availableStock: 10 }
    ]
  }))
}, zl = (e = {}) => ({
  ...Le(Vl),
  ...e
}), Gl = () => ({
  errorCode: -908,
  errorMsg: "Could not find specified address",
  errorIdent: null
}), Ht = [...Array(8).keys()], Fl = {
  pickuppoint: {
    id: 1,
    label: "Pickup Point 1",
    description: "Description of Pickup Point 1"
  },
  status: "SUPPORTED",
  locationFee: 0,
  pricelist: [
    {
      productId: 0,
      price: 150,
      active: !0
    },
    {
      productId: 1,
      price: 750,
      active: !0
    },
    {
      productId: 2,
      price: 300,
      active: !0
    }
  ],
  availability: [
    {
      productId: 0,
      timeslotIds: Ht
    },
    {
      productId: 1,
      timeslotIds: [
        Ht,
        [...Array(12).keys()].map((e) => e + 8)
      ].flat()
      // Also make the 3 following days available
    },
    {
      productId: 2,
      timeslotIds: [
        Ht,
        [...Array(12).keys()].map((e) => e + 12)
      ].flat()
    }
  ],
  inventory: [0, 1, 2, 3, 4, 5, 6].map((e) => ({
    inventoryId: e,
    products: [
      { productId: 0, availableStock: 10 },
      { productId: 1, availableStock: 10 },
      { productId: 2, availableStock: 10 }
    ]
  }))
}, Hl = (e = {}) => ({
  ...Le(Fl),
  ...e
}), Bl = () => ({
  errorCode: -31,
  errorMsg: null,
  errorIdent: null
});
export {
  Ge as LookupError,
  ql as LookupErrorStatus,
  Xt as Mode,
  Tr as TimeslotAvailabilityError,
  Gl as createMockAddressLookupNotFoundResponse,
  zl as createMockAddressLookupResponse,
  Wl as createMockCheckoutDataResponse,
  Bl as createMockPickupPointLookupNotFoundResponse,
  Hl as createMockPickupPointLookupResponse,
  nt as optionalIf,
  Tl as postalCode,
  kt as removeBlank,
  Wn as telephone,
  Ul as useOrderStore
};
//# sourceMappingURL=index.js.map
